/* ROOM03 / HITLIST UTOPIA - stanza Utopia Rooms
   Nata come "room04" (sorgente di riferimento: room04-hitlist.html).
   Dal 12/10/2026 questo file e' la sorgente: le modifiche si fanno qui.

   Revisione 12/10/2026 - armonizzata con Stanza 01 e Stanza 02:
    - rinominata ROOM03 (variabili window.ROOM03_*, asset room03-hitlist.js)
    - "Add to cart" vero (Shopify AJAX) + "Go to cart" + link alla scheda
    - prezzi, varianti, copertine e disponibilita' letti live da Shopify
    - email ricordata (localStorage) gia' al click su Enter: chi e' entrato
      una volta entra subito; ritorno da Shopify con ?entered=1
    - interfaccia e messaggi in inglese
    - joystick nascosto finche' non si entra e con il pannello aperto
    - al tocco lo sguardo trascina il mondo (Street View), mouse invariato
    - resa cinematografica: sguardo con inerzia + respiro della camera
    - tasto Exit con conferma, Esc chiude il pannello
    - overlay spostati sotto <body>: immuni ai transform del tema

   Revisione 12/10/2026 (v3):
    - ingombri (hitbox) ricalcolati sulle misure vere dei mobili: si passa
      fra divano e tavolino; margine dal corpo 0.25 m invece di 0.34
    - niente piu' scambio delle copertine nella "deriva": cartellino e
      copertina restano sempre coerenti (si spostano solo gli oggetti)
    - tolta la macchia bianca della finestra sul pavimento
    - palazzi: tetti con materiale proprio (prima la facciata con le
      finestre era stampata anche sul tetto) e cornicione appoggiato sopra
      il tetto invece che complanare (sfarfallio a righe)
    - pannello prodotto con <img> vera al posto dello sfondo CSS
    - joystick fisso e ben visibile, identico alle Stanze 01 e 02
    - ingresso condiviso fra tutte le stanze (chiave utopia_entered)
    - droni solo nei corridoi fra i palazzi: non li attraversano piu' */
window.__bootRoom03 = function(){
"use strict";
if (window.__room03booted) return;
window.__room03booted = true;

// Overlay come figli diretti di <body>: un transform CSS del tema su un
// antenato romperebbe il loro position:fixed (stessa soluzione delle
// Stanze 01 e 02).
["wrap","readout","hud","hint","stickzone","panel","exit-confirm","entry"].forEach(function(id){
  var el0 = document.getElementById(id);
  if (el0 && el0.parentElement !== document.body) document.body.appendChild(el0);
});

/* ==========================================================================
   -1 / DIAGNOSTICA
   Se qualcosa fallisce la pagina deve dirlo, non diventare nera e tacere.
   ========================================================================== */

var reported = false;
function hasWebGL(){
  try {
    var c = document.createElement("canvas");
    return !!(window.WebGLRenderingContext &&
      (c.getContext("webgl") || c.getContext("experimental-webgl")));
  } catch (e){ return false; }
}
function fatal(title, detail){
  var msg = (detail && (detail.message || detail)) || "";
  if (window.console && console.error) console.error("ROOM03:", title, detail);
  if (reported) return;
  reported = true;
  var d = document.getElementById("fatal");
  if (!d){
    d = document.createElement("div");
    d.id = "fatal";
    d.className = "w95";
    d.style.cssText = "left:50%;top:50%;transform:translate(-50%,-50%);" +
      "width:min(340px,88vw);z-index:99;";
    if (document.body) document.body.appendChild(d);
  }
  d.innerHTML =
    '<div class="bar"><span>ROOM03.exe</span></div>' +
    '<div class="body" style="font:12px/1.6 \'Courier New\',monospace;color:#000">' +
    "<b>" + String(title).replace(/</g, "&lt;") + "</b><br><br>" +
    String(msg).replace(/</g, "&lt;") + "<br><br>" +
    "three.js: " + (typeof THREE === "undefined" ? "NOT LOADED" : "r" + THREE.REVISION) + "<br>" +
    "webgl: " + (hasWebGL() ? "available" : "NOT AVAILABLE") + "<br>" +
    "screen: " + window.innerWidth + "x" + window.innerHeight +
    "</div>";
  var e = document.getElementById("entry");
  if (e) e.style.display = "none";
}
window.addEventListener("error", function(ev){
  // Solo gli errori di questa stanza o di three.js: sulla pagina Shopify
  // girano anche gli script del tema e delle app, che non devono spegnerla.
  if (!ev || !ev.filename || !/room03|three/i.test(ev.filename)) return;
  fatal("Loading error.", (ev && ev.message) || (ev && ev.target && ev.target.src) || "");
});
if (typeof THREE === "undefined"){
  fatal("The 3D library didn't load.",
        "Usually it's the connection, a blocked CDN or a browser extension. Reload the page.");
  return;
}
if (!hasWebGL()){
  fatal("WebGL is not available.",
        "This browser can't open a 3D context. Try a private window or another browser.");
  return;
}

/* ==========================================================================
   00 / CONFIG
   ========================================================================== */

// --- prodotti reali letti da Shopify (Utopia by Sten.js) -------------------
// In produzione questo blocco va generato da Liquid, vedi nota a fine file.
var CDN = "https://cdn.shopify.com/s/files/1/0904/3043/9753/files/";
var PRODUCTS = [
  { code:"VOL. I",   name:"FIRST REPUBLIC",  sub:"Late Capitalism",
    handle:"vol-i-first-republic-late-capitalism-hitlist-utopia",
    img:CDN+"1_2c99cb8a-767c-4c06-b5ff-dd67c0b889a8.png?v=1782207291&width=700",
    price:"60,00", currency:"EUR", edition:5, left:5, variantId:54710049603913, available:true, tracked:true },
  { code:"VOL. II",  name:"ISLAND BOYS",     sub:"Offshore Confessions",
    handle:"vol-ii-island-boys-offshore-confessions-hitlist-utopia",
    img:CDN+"xxxx2.png?v=1782284862&width=700",
    price:"60,00", currency:"EUR", edition:5, left:5, variantId:54713307562313, available:true, tracked:true },
  { code:"VOL. III", name:"ROBIN HOODS",     sub:"Silicon Kingdoms",
    handle:"vol-iii-robin-hoods-silicon-kingdoms-hitlist-utopia",
    img:CDN+"yyyy.png?v=1782286755&width=700",
    price:"60,00", currency:"EUR", edition:5, left:5, variantId:54713314246985, available:true, tracked:true },
  { code:"VOL. IV",  name:"TOP G SUMMIT",    sub:"Sanctioned Luxury",
    handle:"vol-iv-top-g-summit-sanctioned-luxury-hitlist-utopia",
    img:CDN+"zzz1.png?v=1782287306&width=700",
    price:"60,00", currency:"EUR", edition:5, left:5, variantId:54713334563145, available:true, tracked:true },
  { code:"VOL. V",   name:"REALITY BENDERS", sub:"Genius Tax Bracket",
    handle:"vol-v-reality-benders-genius-tax-bracket-hitlist-utopia",
    img:CDN+"aa1.png?v=1782287716&width=700",
    price:"60,00", currency:"EUR", edition:5, left:5, variantId:54713381847369, available:true, tracked:true }
];
var PACK = {
  code:"ARCHIVE", name:"HITLIST UTOPIA", sub:"All Volumes",
  handle:"hitlist-utopia-complete-pack",
  img:CDN+"Neutral_Modern_Living_Room_Wall_Art_Print_Frame_Mockup_Instagram_Post_1.png?v=1782819258&width=700",
  price:"200,00", currency:"EUR", edition:5, left:5, variantId:54747316814153, available:true, tracked:true
};

// --- canali TV -------------------------------------------------------------
// SLOT DA RIEMPIRE. Ogni canale accetta un file video caricato su Shopify
// (Contenuti > File) oppure resta su segnale analogico procedurale.
// { label:"...", src:"https://cdn.shopify.com/.../clip.mp4" }
// Se src è vuoto il canale trasmette rumore / barre / fermo immagine.
var TV_CHANNELS = [
  { label:"01 BROADCAST", src:"" },
  { label:"02 BROADCAST", src:"" },
  { label:"03 BROADCAST", src:"" },
  { label:"04 BARS",      src:"", mode:"bars" },
  { label:"05 NO SIGNAL", src:"", mode:"noise" }
];

// --- override da Shopify Liquid, se presente ------------------------------
// Il liquid stampa questi oggetti prima di caricare lo script, così le
// rimanenze e le copertine restano sempre quelle vere del negozio.
// Ogni volume viene sovrascritto campo per campo: se un prodotto manca nel
// negozio resta il suo fallback, invece di perdere tutti e cinque i dischi.
(function(){
  var live = window.ROOM03_PRODUCTS || [];
  PRODUCTS.forEach(function(p){
    for (var i=0; i<live.length; i++){
      if (live[i] && live[i].handle === p.handle){
        for (var k in live[i]) if (live[i][k] !== null && live[i][k] !== "") p[k] = live[i][k];
      }
    }
  });
  var lp = window.ROOM03_PACK;
  if (lp) for (var k2 in lp) if (lp[k2] !== null && lp[k2] !== "") PACK[k2] = lp[k2];
})();
if (window.ROOM03_CHANNELS && window.ROOM03_CHANNELS.length) TV_CHANNELS = window.ROOM03_CHANNELS;

// --- palette ---------------------------------------------------------------
var C = {
  white:0xf4f2ee, offwhite:0xe6e2da, paper:0xdedad1,
  ink:0x141414, char:0x232323, grey:0x8f8f8a, softgrey:0xb9b7b1,
  red:0xc81414, deepred:0x9d0f0f
};

var ROOM = { w:9.8, d:7.6, h:3.2 };
var EYE = 1.62;
var SPEED = 3.1;
var REACH = 2.9;

/* ==========================================================================
   01 / RENDERER, SCENA, CAMERA
   ========================================================================== */

var isTouchDevice = ("ontouchstart" in window) || navigator.maxTouchPoints > 0;
var wrap = document.getElementById("wrap");
if (typeof THREE === "undefined"){
  fatal("The 3D library didn't load.",
        "The CDN is blocked or the script loaded too late. Reload the page.");
  return;
}
if (!hasWebGL()){
  fatal("WebGL is not available.",
        "Try disabling extensions or opening the page in a private window.");
  return;
}
var scene = new THREE.Scene();
scene.background = new THREE.Color(C.white);
scene.fog = new THREE.Fog(C.white, 30, 260);

var camera = new THREE.PerspectiveCamera(62, window.innerWidth/window.innerHeight, 0.05, 200);
camera.position.set(0, EYE, 2.9);

var renderer;
try {
  renderer = new THREE.WebGLRenderer({ antialias:true, powerPreference:"high-performance" });
} catch (err) {
  fatal("WebGL is not available.",
        "The browser couldn't open a 3D context. On iOS this happens with Low Power Mode on or too many open tabs.");
  return;
}
renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, isTouchDevice ? 1.5 : 2));
renderer.setSize(window.innerWidth, window.innerHeight);
if (THREE.sRGBEncoding !== undefined) renderer.outputEncoding = THREE.sRGBEncoding;
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
wrap.appendChild(renderer.domElement);
renderer.domElement.addEventListener("webglcontextlost", function(ev){
  ev.preventDefault();
  fatal("The 3D scene was unloaded.", "The browser freed the graphics memory. Reload the page.");
});

window.addEventListener("resize", function(){
  camera.aspect = window.innerWidth/window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
});

/* ==========================================================================
   02 / LUCE
   ========================================================================== */

scene.add(new THREE.HemisphereLight(0xffffff, 0xdedad2, 0.70));

var sun = new THREE.DirectionalLight(0xffffff, 0.47);
sun.position.set(9, 7.5, -2);
sun.castShadow = true;
sun.shadow.mapSize.set(1024, 1024);
sun.shadow.camera.left = -8; sun.shadow.camera.right = 8;
sun.shadow.camera.top = 8;    sun.shadow.camera.bottom = -8;
sun.shadow.camera.far = 40;
sun.shadow.bias = -0.0012;
scene.add(sun);

// alone del televisore, unica fonte calda dell'ambiente
var tvGlow = new THREE.PointLight(0xffe8e2, 0.38, 8.5, 2);
tvGlow.position.set(0, 1.35, -3.1);
scene.add(tvGlow);

/* ==========================================================================
   03 / MATERIALI
   ========================================================================== */

function mat(color, rough, metal){
  return new THREE.MeshStandardMaterial({
    color: color,
    roughness: rough === undefined ? 0.9 : rough,
    metalness: metal === undefined ? 0.0 : metal
  });
}
var M = {
  wall:    mat(C.white, 0.97),
  floor:   mat(C.offwhite, 0.94),
  ceiling: mat(0xfbfaf8, 1.0),
  ink:     mat(C.ink, 0.72),
  char:    mat(C.char, 0.6),
  grey:    mat(C.grey, 0.85),
  softgrey:mat(C.softgrey, 0.9),
  red:     mat(C.red, 0.62),
  deepred: mat(C.deepred, 0.6),
  paper:   mat(C.paper, 1.0),
  chrome:  mat(0xbfbfbb, 0.35, 0.75),
  glass:   new THREE.MeshStandardMaterial({
             color:0xffffff, roughness:0.06, metalness:0.0,
             transparent:true, opacity:0.16, side:THREE.DoubleSide })
};

function box(w,h,d,material,x,y,z,parent){
  var m = new THREE.Mesh(new THREE.BoxGeometry(w,h,d), material);
  m.position.set(x,y,z);
  m.castShadow = true; m.receiveShadow = true;
  (parent || scene).add(m);
  return m;
}
function cyl(rt,rb,h,seg,material,x,y,z,parent){
  var m = new THREE.Mesh(new THREE.CylinderGeometry(rt,rb,h,seg), material);
  m.position.set(x,y,z);
  m.castShadow = true; m.receiveShadow = true;
  (parent || scene).add(m);
  return m;
}

/* ==========================================================================
   04 / STANZA BIANCA
   ========================================================================== */

var floor = new THREE.Mesh(new THREE.PlaneGeometry(ROOM.w, ROOM.d), M.floor);
floor.rotation.x = -Math.PI/2;
floor.receiveShadow = true;
scene.add(floor);

var ceil = new THREE.Mesh(new THREE.PlaneGeometry(ROOM.w, ROOM.d), M.ceiling);
ceil.rotation.x = Math.PI/2;
ceil.position.y = ROOM.h;
scene.add(ceil);

function wall(w,h,x,y,z,ry){
  var m = new THREE.Mesh(new THREE.PlaneGeometry(w,h), M.wall);
  m.position.set(x,y,z);
  m.rotation.y = ry;
  m.receiveShadow = true;
  scene.add(m);
  return m;
}
var HW = ROOM.w/2, HD = ROOM.d/2;
wall(ROOM.w, ROOM.h, 0, ROOM.h/2, -HD, 0);            // nord, parete TV
wall(ROOM.w, ROOM.h, 0, ROOM.h/2,  HD, Math.PI);      // sud
wall(ROOM.d, ROOM.h, -HW, ROOM.h/2, 0, Math.PI/2);    // ovest, parete galleria
// est: costruita a pezzi per lasciare il vano finestra
(function eastWall(){
  var wx = HW, sillY = 1.02, winH = 1.72, winW = 2.7, winZ = -0.4;
  var ry = -Math.PI/2;
  var m1 = new THREE.Mesh(new THREE.PlaneGeometry(ROOM.d, sillY), M.wall);
  m1.position.set(wx, sillY/2, 0); m1.rotation.y = ry; m1.receiveShadow = true; scene.add(m1);
  var topH = ROOM.h - (sillY + winH);
  var m2 = new THREE.Mesh(new THREE.PlaneGeometry(ROOM.d, topH), M.wall);
  m2.position.set(wx, sillY + winH + topH/2, 0); m2.rotation.y = ry; m2.receiveShadow = true; scene.add(m2);
  var leftLen = (winZ - winW/2) - (-HD);
  var m3 = new THREE.Mesh(new THREE.PlaneGeometry(leftLen, winH), M.wall);
  m3.position.set(wx, sillY + winH/2, -HD + leftLen/2); m3.rotation.y = ry; m3.receiveShadow = true; scene.add(m3);
  var rightLen = HD - (winZ + winW/2);
  var m4 = new THREE.Mesh(new THREE.PlaneGeometry(rightLen, winH), M.wall);
  m4.position.set(wx, sillY + winH/2, HD - rightLen/2); m4.rotation.y = ry; m4.receiveShadow = true; scene.add(m4);
})();

// battiscopa nero: linea grafica che tiene insieme il bianco
(function skirting(){
  var h = 0.09, t = 0.03;
  box(ROOM.w, h, t, M.ink, 0, h/2, -HD + t/2);
  box(ROOM.w, h, t, M.ink, 0, h/2,  HD - t/2);
  box(t, h, ROOM.d, M.ink, -HW + t/2, h/2, 0);
  box(t, h, ROOM.d, M.ink,  HW - t/2, h/2, 0);
})();

// tappeto rosso, grande: e' lui a definire il perimetro del salotto
(function rug(){
  var m = new THREE.Mesh(new THREE.PlaneGeometry(6.6, 4.6), mat(C.deepred, 1.0));
  m.rotation.x = -Math.PI/2; m.position.set(0, 0.008, -1.30);
  m.receiveShadow = true; scene.add(m);
  var inner = new THREE.Mesh(new THREE.PlaneGeometry(6.0, 4.0), mat(0xa41111, 1.0));
  inner.rotation.x = -Math.PI/2; inner.position.set(0, 0.012, -1.30);
  inner.receiveShadow = true; scene.add(inner);
  var line = new THREE.Mesh(new THREE.PlaneGeometry(5.6, 3.6),
    new THREE.MeshBasicMaterial({ color:0x141414, transparent:true, opacity:0.14 }));
  line.rotation.x = -Math.PI/2; line.position.set(0, 0.014, -1.30);
  scene.add(line);
})();

/* ==========================================================================
   05 / COLLISIONI
   ========================================================================== */

var BLOCKS = [];
function blocker(cx, cz, sx, sz){
  BLOCKS.push({ x0:cx-sx/2, x1:cx+sx/2, z0:cz-sz/2, z1:cz+sz/2 });
}

/* ==========================================================================
   06 / INTERATTIVI
   ========================================================================== */

var INTERACTIVE = [];

// La stanza si riscrive mentre la abiti. Ogni oggetto registrato qui puo'
// essere spostato, ma solo dopo essersi guastato per un secondo.
var DRIFT = [];
function driftable(obj, range, comp){
  DRIFT.push({
    o: obj,
    home: obj.position.clone(),
    range: (range === undefined ? 0.20 : range),
    comp: comp || ["x", "z"]     // assi lungo cui l'oggetto puo' scivolare
  });
}
var FLOWERS = [];
function interactive(mesh, kind, payload, label){
  mesh.userData.kind = kind;
  mesh.userData.payload = payload;
  mesh.userData.label = label;
  INTERACTIVE.push(mesh);
  return mesh;
}

/* ==========================================================================
   07 / TEXTURE PROCEDURALI E LOADER
   ========================================================================== */

function makeCanvas(w,h){
  var c = document.createElement("canvas");
  c.width = w; c.height = h;
  return c;
}
function canvasTexture(c){
  var t = new THREE.CanvasTexture(c);
  if (THREE.sRGBEncoding !== undefined) t.encoding = THREE.sRGBEncoding;
  t.anisotropy = 4;
  return t;
}

// copertine: immagine reale Shopify con fallback procedurale
// Le copertine arrivano da un altro dominio. Se le disegno dentro un canvas
// quel canvas diventa "tainted" e il browser fa saltare sia getImageData sia
// l'upload della texture: la scena muore e resta schermo nero. Quindi la
// copertina viene caricata direttamente come texture, senza passare da canvas.
var coverTextures = [];
var coverUsers = [];

function useCover(idx, mesh){
  (coverUsers[idx] = coverUsers[idx] || []).push(mesh);
}

function coverTexture(p, idx){
  // fallback disegnato: si vede subito, e resta se la rete non risponde
  var c = makeCanvas(512,512);
  var ctx = c.getContext("2d");
  ctx.fillStyle = "#141414"; ctx.fillRect(0,0,512,512);
  ctx.fillStyle = "#c81414"; ctx.fillRect(0,432,512,8);
  ctx.fillStyle = "#f4f2ee";
  ctx.font = "600 44px 'Courier New', monospace";
  ctx.fillText(p.code, 34, 96);
  ctx.font = "600 30px 'Courier New', monospace";
  ctx.fillText("HITLIST", 34, 470);
  var tex = canvasTexture(c);
  coverTextures[idx] = tex;

  try {
    var loader = new THREE.TextureLoader();
    if (loader.setCrossOrigin) loader.setCrossOrigin("anonymous");
    loader.load(p.img, function(t){
      if (THREE.sRGBEncoding !== undefined) t.encoding = THREE.sRGBEncoding;
      t.anisotropy = 4;
      coverTextures[idx] = t;
      (coverUsers[idx] || []).forEach(function(m){
        m.material.map = t;
        m.material.needsUpdate = true;
      });
    }, undefined, function(){ /* resta il fallback disegnato */ });
  } catch (e){ /* resta il fallback disegnato */ }

  return tex;
}

/* ==========================================================================
   08 / TELEVISORE
   ========================================================================== */

var TV = {
  canvas:null, ctx:null, tex:null,
  channel:0, mode:"noise", video:null,
  vhs:false, vhsIdx:0, vhsT:0,
  t:0, acc:0
};

function buildTV(){
  var g = new THREE.Group();
  g.position.set(0, 0, -3.25);
  scene.add(g);

  // mobile TV
  var cab = box(2.9, 0.52, 0.62, M.ink, 0, 0.26, 0.06, g);
  box(2.86, 0.03, 0.60, M.grey, 0, 0.50, 0.06, g);
  // ante rosse
  box(1.32, 0.34, 0.02, M.deepred, -0.7, 0.26, 0.38, g);
  box(1.32, 0.34, 0.02, M.deepred,  0.7, 0.26, 0.38, g);

  // corpo televisore
  var bodyY = 0.52 + 0.42;
  var body = box(1.42, 0.84, 0.72, M.char, 0, bodyY, 0.02, g);
  // cornice frontale leggermente sporgente
  box(1.46, 0.88, 0.05, M.ink, 0, bodyY, 0.37, g);

  // schermo
  TV.canvas = makeCanvas(512, 384);
  TV.ctx = TV.canvas.getContext("2d");
  TV.tex = canvasTexture(TV.canvas);
  var screenMat = new THREE.MeshBasicMaterial({ map:TV.tex });
  var screen = new THREE.Mesh(new THREE.PlaneGeometry(1.08, 0.62), screenMat);
  screen.position.set(-0.11, bodyY + 0.03, 0.401);
  g.add(screen);
  TV.screen = screen;

  // strato di degrado del nastro: canvas separato, non tocca mai immagini
  // esterne, quindi puo' essere sovrapposto anche alle copertine
  TV.ovCanvas = makeCanvas(512, 384);
  TV.ovCtx = TV.ovCanvas.getContext("2d");
  TV.ovTex = canvasTexture(TV.ovCanvas);
  var overlay = new THREE.Mesh(new THREE.PlaneGeometry(1.08, 0.62),
    new THREE.MeshBasicMaterial({ map:TV.ovTex, transparent:true, depthWrite:false }));
  overlay.position.set(-0.11, bodyY + 0.03, 0.4035);
  overlay.visible = false;
  g.add(overlay);
  TV.overlay = overlay;
  interactive(screen, "tv", null, "CHANGE CHANNEL");

  // vetro bombato molto leggero
  var glass = new THREE.Mesh(new THREE.PlaneGeometry(1.12, 0.66), M.glass);
  glass.position.set(-0.11, bodyY + 0.03, 0.406);
  g.add(glass);

  // colonna comandi a destra: speaker, tasti, led
  var sp = box(0.14, 0.44, 0.02, mat(0x1c1c1c, 0.95), 0.56, bodyY + 0.08, 0.402, g);
  // la griglia e' dipinta, non ventisette cilindri
  var grillC = makeCanvas(64, 192);
  var gx2 = grillC.getContext("2d");
  gx2.fillStyle = "#1c1c1c"; gx2.fillRect(0,0,64,192);
  gx2.fillStyle = "#0a0a0a";
  for (var r=0; r<18; r++){
    for (var cc=0; cc<5; cc++){
      gx2.beginPath(); gx2.arc(11 + cc*11, 9 + r*10, 3, 0, Math.PI*2); gx2.fill();
    }
  }
  var grill = new THREE.Mesh(new THREE.PlaneGeometry(0.12, 0.4),
    new THREE.MeshBasicMaterial({ map:canvasTexture(grillC) }));
  grill.position.set(0.56, bodyY + 0.08, 0.409);
  g.add(grill);
  for (var b=0; b<3; b++){
    var btn = cyl(0.018,0.018,0.012,10, M.softgrey, 0.5 + b*0.045, bodyY - 0.24, 0.406, g);
    btn.rotation.x = Math.PI/2; btn.castShadow = false;
  }
  var led = cyl(0.011,0.011,0.008,10, new THREE.MeshBasicMaterial({color:C.red}), 0.605, bodyY - 0.24, 0.406, g);
  led.rotation.x = Math.PI/2; led.castShadow = false;
  TV.led = led;

  // antenne a V
  var a1 = cyl(0.006,0.008,0.95,6, M.chrome, -0.2, bodyY + 0.85, -0.1, g);
  a1.rotation.z = 0.42; a1.rotation.x = -0.16;
  var a2 = cyl(0.006,0.008,0.95,6, M.chrome, 0.2, bodyY + 0.85, -0.1, g);
  a2.rotation.z = -0.42; a2.rotation.x = -0.16;
  box(0.16,0.05,0.12, M.ink, 0, bodyY + 0.45, -0.1, g);

  // videocassetta UTOPIA HIT LIST sopra il televisore
  var vhsG = new THREE.Group();
  vhsG.position.set(-0.42, bodyY + 0.465, 0.08);
  g.add(vhsG);
  var shell = box(0.42, 0.045, 0.24, M.ink, 0, 0, 0, vhsG);
  driftable(vhsG, 0.09);
  var lbl = makeCanvas(256,128);
  var lc = lbl.getContext("2d");
  lc.fillStyle = "#e6e2da"; lc.fillRect(0,0,256,128);
  lc.fillStyle = "#c81414"; lc.fillRect(0,0,256,14);
  lc.fillStyle = "#141414";
  lc.font = "700 24px 'Courier New', monospace";
  lc.fillText("UTOPIA", 16, 56);
  lc.fillText("HIT LIST", 16, 86);
  lc.fillStyle = "#8f8f8a";
  lc.font = "13px 'Courier New', monospace";
  lc.fillText("VHS / E-180", 16, 112);
  var lblMesh = new THREE.Mesh(new THREE.PlaneGeometry(0.34, 0.17), new THREE.MeshBasicMaterial({map:canvasTexture(lbl)}));
  lblMesh.rotation.x = -Math.PI/2;
  lblMesh.position.set(0, 0.024, 0);
  vhsG.add(lblMesh);
  interactive(shell, "vhs", null, "INSERT THE TAPE");
  TV.vhsMesh = shell;

  blocker(0, -3.23, 2.9, 0.72);   // mobile + televisore
  return g;
}
var tvGroup = buildTV();

// --- disegno del segnale ---------------------------------------------------
function tvNoise(ctx, w, h, amount){
  try {
    var img = ctx.getImageData(0,0,w,h);
    var d = img.data;
    for (var i=0; i<d.length; i+=4){
      if (Math.random() < amount){
        var v = 20 + Math.random()*215;
        d[i]=v; d[i+1]=v; d[i+2]=v;
      }
    }
    ctx.putImageData(img,0,0);
  } catch (e){
    // canvas contaminato da un video esterno: rumore disegnato invece che letto
    var n = Math.floor(amount * 1200);
    for (var k=0; k<n; k++){
      var g = Math.floor(20 + Math.random()*215);
      ctx.fillStyle = "rgb(" + g + "," + g + "," + g + ")";
      ctx.fillRect(Math.random()*w, Math.random()*h, 2, 2);
    }
  }
}
function tvScanlines(ctx, w, h){
  ctx.fillStyle = "rgba(0,0,0,0.16)";
  for (var y=0; y<h; y+=3) ctx.fillRect(0,y,w,1);
  var g = ctx.createRadialGradient(w/2,h/2,h*0.28, w/2,h/2,h*0.82);
  g.addColorStop(0,"rgba(0,0,0,0)");
  g.addColorStop(1,"rgba(0,0,0,0.5)");
  ctx.fillStyle = g; ctx.fillRect(0,0,w,h);
}
function tvChannelStamp(ctx, w, label){
  ctx.fillStyle = "rgba(244,242,238,0.92)";
  ctx.font = "700 20px 'Courier New', monospace";
  ctx.fillText(label, 18, 34);
}

function drawTV(dt){
  var ctx = TV.ctx, w = TV.canvas.width, h = TV.canvas.height;
  TV.t += dt;

  if (TV.vhs){
    // Canale fuori palinsesto: l'archivio falso trasmesso dalla macchina del
    // vero. La copertina entra come texture dello schermo, il degrado del
    // nastro viene disegnato sopra su un canvas separato.
    TV.vhsT += dt;
    if (TV.vhsT > 4.2){ TV.vhsT = 0; TV.vhsIdx = (TV.vhsIdx + 1) % PRODUCTS.length; }

    var ct = coverTextures[TV.vhsIdx];
    if (ct && TV.screen.material.map !== ct){
      TV.screen.material.map = ct;
      TV.screen.material.needsUpdate = true;
    }
    TV.overlay.visible = true;

    var o = TV.ovCtx, ow = TV.ovCanvas.width, oh = TV.ovCanvas.height;
    o.clearRect(0, 0, ow, oh);
    for (var k=0; k<4; k++){
      o.fillStyle = "rgba(244,242,238,0.12)";
      o.fillRect(0, Math.random()*oh, ow, 1 + Math.random()*3);
    }
    if (Math.random() < 0.05){ o.fillStyle = "rgba(200,20,20,0.16)"; o.fillRect(0,0,ow,oh); }
    if (Math.random() < 0.10){ o.fillStyle = "rgba(20,20,20,0.30)"; o.fillRect(0, Math.random()*oh, ow, 10); }
    o.fillStyle = "rgba(244,242,238,0.92)";
    o.font = "700 17px 'Courier New', monospace";
    o.fillText("PLAY", 18, 30);
    o.fillText("SP  00:0" + (TV.vhsIdx+1) + ":" +
               String(Math.floor(TV.vhsT*10)).padStart(2,"0"), 18, oh-20);
    o.fillText(PRODUCTS[TV.vhsIdx].code, ow-96, oh-20);
    tvScanlines(o, ow, oh);
    TV.ovTex.needsUpdate = true;
    return;
  }

  // fuori dal nastro lo schermo torna al proprio canvas
  if (TV.screen.material.map !== TV.tex){
    TV.screen.material.map = TV.tex;
    TV.screen.material.needsUpdate = true;
  }
  if (TV.overlay) TV.overlay.visible = false;

  var ch = TV_CHANNELS[TV.channel];
  var mode = ch.mode || (ch.src ? "video" : "signal");

  if (mode === "video" && TV.video && TV.video.readyState >= 2){
    ctx.fillStyle = "#000"; ctx.fillRect(0,0,w,h);
    var vr = TV.video.videoWidth / TV.video.videoHeight || 1.33;
    var dw = w, dh = w/vr;
    if (dh < h){ dh = h; dw = h*vr; }
    ctx.drawImage(TV.video, (w-dw)/2, (h-dh)/2, dw, dh);
    tvNoise(ctx, w, h, 0.012);
    tvChannelStamp(ctx, w, ch.label);
    tvScanlines(ctx, w, h);
    TV.tex.needsUpdate = true;
    return;
  }

  if (mode === "bars"){
    var cols = ["#f4f2ee","#e6e2da","#b9b7b1","#8f8f8a","#4a4a48","#c81414","#141414"];
    var bw = w/cols.length;
    for (var i=0; i<cols.length; i++){ ctx.fillStyle = cols[i]; ctx.fillRect(i*bw,0,bw+1,h*0.82); }
    ctx.fillStyle = "#141414"; ctx.fillRect(0,h*0.82,w,h*0.18);
    ctx.fillStyle = "#f4f2ee";
    ctx.font = "700 18px 'Courier New', monospace";
    ctx.fillText("UTOPIA BROADCASTING", 16, h-18);
    tvNoise(ctx, w, h, 0.01);
    tvScanlines(ctx, w, h);
    TV.tex.needsUpdate = true;
    return;
  }

  if (mode === "noise"){
    ctx.fillStyle = "#2a2a2a"; ctx.fillRect(0,0,w,h);
    tvNoise(ctx, w, h, 0.85);
    ctx.fillStyle = "rgba(20,20,20,0.55)";
    ctx.fillRect(0, h/2-22, w, 44);
    ctx.fillStyle = "#f4f2ee";
    ctx.font = "700 19px 'Courier New', monospace";
    ctx.fillText("NO SIGNAL", w/2-62, h/2+7);
    tvScanlines(ctx, w, h);
    TV.tex.needsUpdate = true;
    return;
  }

  // segnale in attesa di contenuto: fermo immagine analogico con roll
  ctx.fillStyle = "#1b1b1b"; ctx.fillRect(0,0,w,h);
  var roll = (TV.t*26) % h;
  ctx.fillStyle = "rgba(244,242,238,0.05)";
  ctx.fillRect(0, roll-40, w, 40);
  ctx.strokeStyle = "rgba(244,242,238,0.16)";
  ctx.lineWidth = 1;
  for (var gx=0; gx<w; gx+=32){ ctx.beginPath(); ctx.moveTo(gx,0); ctx.lineTo(gx,h); ctx.stroke(); }
  for (var gy=0; gy<h; gy+=32){ ctx.beginPath(); ctx.moveTo(0,gy); ctx.lineTo(w,gy); ctx.stroke(); }
  ctx.fillStyle = "#c81414";
  ctx.fillRect(w/2-56, h/2-30, 112, 60);
  ctx.fillStyle = "#f4f2ee";
  ctx.font = "700 15px 'Courier New', monospace";
  ctx.fillText("NO", w/2-11, h/2-4);
  ctx.fillText("TAPE", w/2-23, h/2+18);
  tvNoise(ctx, w, h, 0.06);
  tvChannelStamp(ctx, w, ch.label);
  tvScanlines(ctx, w, h);
  TV.tex.needsUpdate = true;
}

function loadChannelVideo(){
  var ch = TV_CHANNELS[TV.channel];
  if (TV.video){ TV.video.pause(); TV.video.src = ""; TV.video = null; }
  if (!ch.src) return;
  var v = document.createElement("video");
  v.crossOrigin = "anonymous";
  v.loop = true; v.muted = true; v.playsInline = true;
  v.setAttribute("playsinline","");
  v.src = ch.src;
  v.play().catch(function(){});
  TV.video = v;
}
function setChannel(i){
  TV.vhs = false;
  TV.channel = ((i % TV_CHANNELS.length) + TV_CHANNELS.length) % TV_CHANNELS.length;
  loadChannelVideo();
  document.getElementById("chLabel").textContent = TV_CHANNELS[TV.channel].label;
  Audio_.click();
}
function toggleVHS(){
  TV.vhs = !TV.vhs;
  if (TV.vhs){
    if (TV.video){ TV.video.pause(); }
    TV.vhsIdx = 0; TV.vhsT = 0;
    document.getElementById("chLabel").textContent = "VHS / UTOPIA HIT LIST";
    Audio_.clunk();
  } else {
    loadChannelVideo();
    document.getElementById("chLabel").textContent = TV_CHANNELS[TV.channel].label;
    Audio_.click();
  }
}

/* ==========================================================================
   09 / DIVANO
   ========================================================================== */

(function sofa(){
  var g = new THREE.Group();
  g.position.set(0, 0, 0.15);
  g.rotation.y = Math.PI;   // schienale verso il fondo stanza, seduta rivolta al televisore
  scene.add(g);

  box(3.15, 0.36, 1.0, M.red, 0, 0.34, 0, g);          // seduta
  box(3.15, 0.72, 0.26, M.red, 0, 0.7, -0.5, g);        // schienale
  box(0.28, 0.62, 1.0, M.red, -1.58, 0.47, 0, g);       // bracciolo sx
  box(0.28, 0.62, 1.0, M.red,  1.58, 0.47, 0, g);       // bracciolo dx
  // cuscini bianco sporco: tre sedute
  for (var i=-1; i<=1; i++){
    var c = box(0.92, 0.14, 0.9, M.paper, i*1.0, 0.59, 0.02, g);
    c.rotation.z = 0.01*i;
  }
  // piedini neri
  var fx = [-1.45, 1.45], fz = [-0.4, 0.4];
  for (var a=0; a<2; a++) for (var b=0; b<2; b++)
    box(0.08, 0.16, 0.08, M.ink, fx[a], 0.08, fz[b], g);

  // ingombro reale: braccioli compresi (3.44 m), dal bordo della seduta
  // (z -0.35) al retro dello schienale (z 0.78)
  blocker(0, 0.215, 3.44, 1.13);
})();

/* ==========================================================================
   10 / TAVOLINO E OGGETTI
   ========================================================================== */

(function coffeeTable(){
  var g = new THREE.Group();
  g.position.set(0, 0, -1.50);
  scene.add(g);

  box(1.5, 0.06, 0.78, M.paper, 0, 0.42, 0, g);
  var lx = [-0.68, 0.68], lz = [-0.32, 0.32];
  for (var a=0; a<2; a++) for (var b=0; b<2; b++)
    box(0.05, 0.42, 0.05, M.ink, lx[a], 0.21, lz[b], g);

  // telecomando
  var rem = box(0.17, 0.032, 0.06, M.ink, -0.42, 0.462, 0.14, g);
  driftable(rem, 0.20);
  var rbtn = box(0.022, 0.006, 0.022, M.red, -0.48, 0.48, 0.14, g);
  rbtn.castShadow = false;
  for (var r=0; r<4; r++){
    var k = box(0.014, 0.004, 0.014, M.softgrey, -0.41 + r*0.026, 0.479, 0.14, g);
    k.castShadow = false;
  }
  interactive(rem, "remote", null, "CHANGE CHANNEL");

  // posacenere
  var ash = cyl(0.075, 0.065, 0.035, 16, M.softgrey, 0.34, 0.457, -0.16, g);
  driftable(ash, 0.18);
  cyl(0.055, 0.05, 0.03, 16, M.paper, 0.34, 0.468, -0.16, g);

  // giornale piegato
  var np = makeCanvas(256, 160);
  var nc = np.getContext("2d");
  nc.fillStyle = "#dedad1"; nc.fillRect(0,0,256,160);
  nc.fillStyle = "#141414";
  nc.fillRect(14, 14, 228, 3);
  nc.font = "700 21px 'Courier New', monospace";
  nc.fillText("ARCHIVE", 14, 46);
  nc.fillStyle = "#c81414"; nc.fillRect(14, 54, 96, 4);
  nc.fillStyle = "#8f8f8a";
  for (var ln=0; ln<9; ln++) nc.fillRect(14, 70 + ln*9, 100 + Math.random()*126, 3);
  nc.fillStyle = "#141414"; nc.fillRect(150, 66, 92, 62);
  var npm = new THREE.Mesh(new THREE.PlaneGeometry(0.36, 0.225),
            new THREE.MeshStandardMaterial({map:canvasTexture(np), roughness:1}));
  npm.rotation.x = -Math.PI/2; npm.rotation.z = -0.12;
  npm.position.set(0.06, 0.452, 0.2);
  driftable(npm, 0.17);
  g.add(npm);

  blocker(0, -1.50, 1.5, 0.78);   // misure del piano, non di piu'
})();

/* ==========================================================================
   11 / CREDENZA, TELEFONO, VHS, TV SECONDARIA, PIANTA, LAMPADA, OROLOGIO
   ========================================================================== */

(function sideboard(){
  var g = new THREE.Group();
  g.position.set(-4.4, 0, 2.25);
  scene.add(g);

  box(0.5, 0.78, 2.4, M.ink, 0, 0.39, 0, g);
  box(0.54, 0.04, 2.44, M.paper, 0, 0.8, 0, g);
  box(0.02, 0.5, 0.9, M.deepred, 0.26, 0.42, -0.5, g);
  box(0.02, 0.5, 0.9, M.deepred, 0.26, 0.42, 0.5, g);

  // videocassette in fila
  for (var i=0; i<5; i++){
    var t = box(0.24, 0.28, 0.045, M.char, 0.02, 0.96, -0.7 + i*0.075, g);
    t.rotation.y = Math.PI/2;
    var strip = box(0.24, 0.06, 0.002, M.paper, 0.02, 1.02, -0.7 + i*0.075 + 0.024, g);
    strip.rotation.y = Math.PI/2; strip.castShadow = false;
  }

  // telefono fisso
  var ph = new THREE.Group(); ph.position.set(0, 0.82, 0.62); g.add(ph);
  driftable(ph, 0.11);
  box(0.26, 0.06, 0.2, M.ink, 0, 0.03, 0, ph);
  box(0.26, 0.05, 0.06, M.char, 0, 0.085, -0.06, ph);
  var padC = makeCanvas(96, 128);
  var pdx = padC.getContext("2d");
  pdx.fillStyle = "#141414"; pdx.fillRect(0,0,96,128);
  pdx.fillStyle = "#b9b7b1";
  for (var rr=0; rr<4; rr++) for (var cc2=0; cc2<3; cc2++){
    pdx.fillRect(10 + cc2*28, 10 + rr*29, 20, 20);
  }
  var pad = new THREE.Mesh(new THREE.PlaneGeometry(0.17, 0.13),
    new THREE.MeshBasicMaterial({ map:canvasTexture(padC) }));
  pad.rotation.x = -Math.PI/2;
  pad.position.set(0, 0.062, 0.02);
  ph.add(pad);

  blocker(-4.4, 2.25, 0.6, 2.5);
})();

// cofanetto completo, appoggiato sul mobile TV
(function packBox(){
  var g = new THREE.Group();
  g.position.set(1.02, 0.52, -3.00);
  scene.add(g);
  var b = box(0.36, 0.11, 0.32, M.ink, 0, 0.055, 0, g);
  var tex = coverTexture(PACK, 99);
  var top = new THREE.Mesh(new THREE.PlaneGeometry(0.3, 0.26),
            new THREE.MeshStandardMaterial({map:tex, roughness:0.55}));
  top.rotation.x = -Math.PI/2; top.position.set(0, 0.112, 0);
  g.add(top);
  useCover(99, top);
  var band = box(0.37, 0.02, 0.33, M.red, 0, 0.03, 0, g);
  band.castShadow = false;
  interactive(b, "product", PACK, "COMPLETE ARCHIVE");
  driftable(g, 0.13);
})();

// Un solo fiore, disegnato come una stampa: livello di colore fuori registro
// sotto, contorno nero pieno sopra. Palette della stanza, niente verde.
function flowerTexture(){
  var c = makeCanvas(512, 1024);
  var x = c.getContext("2d");
  var CX = 256, CY = 300, N = 7, R = 134, PW = 61, PH = 90, CORE = 82;

  function petal(i, ox, oy, op){
    x.save();
    x.translate(CX + ox, CY + oy);
    x.rotate((i/N)*Math.PI*2 + 0.22);
    x.beginPath();
    x.ellipse(0, -R, PW, PH, 0, 0, Math.PI*2);
    op();
    x.restore();
  }
  function leaf(side, y, ox, oy, op){
    x.save();
    x.translate(CX + ox + side*76, CY + y + oy);
    x.rotate(side * 0.72);
    x.beginPath();
    x.ellipse(0, 0, 82, 26, 0, 0, Math.PI*2);
    op();
    x.restore();
  }
  var fill = function(){ x.fill(); };
  var stroke = function(){ x.stroke(); };

  // ---- livello colore, spostato di qualche millimetro ----------------------
  x.fillStyle = "#8f8f8a";
  x.fillRect(CX - 26, CY + 11, 26, 690);
  leaf(-1, 300, -13, 11, fill);
  leaf( 1, 430, -13, 11, fill);
  x.fillStyle = "#c81414";
  for (var i=0; i<N; i++) petal(i, -13, 11, fill);

  x.strokeStyle = "#141414";
  x.lineJoin = "round"; x.lineCap = "round";

  // ---- stelo e foglie, sotto: i petali li coprono in alto -----------------
  x.fillStyle = "#f4f2ee";
  x.fillRect(CX - 13, CY, 26, 700);
  leaf(-1, 300, 0, 0, fill);
  leaf( 1, 430, 0, 0, fill);
  x.lineWidth = 12;
  x.beginPath();
  x.moveTo(CX - 13, CY); x.lineTo(CX - 13, CY + 700);
  x.moveTo(CX + 13, CY); x.lineTo(CX + 13, CY + 700);
  x.stroke();
  x.lineWidth = 11;
  leaf(-1, 300, 0, 0, stroke);
  leaf( 1, 430, 0, 0, stroke);

  // ---- corolla ------------------------------------------------------------
  x.fillStyle = "#f4f2ee";
  for (i=0; i<N; i++) petal(i, 0, 0, fill);
  x.lineWidth = 12;
  for (i=0; i<N; i++) petal(i, 0, 0, stroke);

  // ---- il disco centrale copre gli attacchi dei petali --------------------
  x.fillStyle = "#8f8f8a";
  x.beginPath(); x.arc(CX - 13, CY + 11, CORE, 0, Math.PI*2); x.fill();
  x.fillStyle = "#e6e2da";
  x.beginPath(); x.arc(CX, CY, CORE, 0, Math.PI*2); x.fill();
  x.lineWidth = 13;
  x.beginPath(); x.arc(CX, CY, CORE, 0, Math.PI*2); x.stroke();

  // ---- faccia -------------------------------------------------------------
  x.fillStyle = "#141414";
  x.beginPath(); x.arc(CX - 27, CY - 16, 10, 0, Math.PI*2); x.fill();
  x.beginPath(); x.arc(CX + 27, CY - 16, 10, 0, Math.PI*2); x.fill();
  x.lineWidth = 9;
  x.beginPath(); x.arc(CX, CY + 4, 30, 0.16*Math.PI, 0.84*Math.PI); x.stroke();

  var t = canvasTexture(c);
  t.transparent = true;
  return t;
}

(function plant(){
  var g = new THREE.Group();
  g.position.set(3.9, 0, -2.95);
  g.rotation.y = -0.5;
  scene.add(g);
  cyl(0.21, 0.16, 0.36, 16, M.ink, 0, 0.18, 0, g);
  cyl(0.22, 0.22, 0.03, 16, M.char, 0, 0.37, 0, g);
  cyl(0.19, 0.19, 0.02, 16, mat(0x2a2a28, 1.0), 0, 0.38, 0, g);

  var flower = new THREE.Mesh(new THREE.PlaneGeometry(0.56, 1.12),
    new THREE.MeshBasicMaterial({ map:flowerTexture(), transparent:true, side:THREE.DoubleSide }));
  flower.position.set(0, 0.94, 0.01);
  flower.userData.parentYaw = g.rotation.y;
  g.add(flower);
  FLOWERS.push(flower);

  blocker(3.9, -2.95, 0.5, 0.5);
})();

// lampada da terra
(function lamp(){
  var g = new THREE.Group();
  g.position.set(-2.35, 0, -2.35);
  scene.add(g);
  cyl(0.19, 0.22, 0.04, 18, M.ink, 0, 0.02, 0, g);
  cyl(0.022, 0.022, 1.55, 10, M.ink, 0, 0.79, 0, g);
  var shade = cyl(0.16, 0.26, 0.32, 20, new THREE.MeshStandardMaterial({
    color:C.paper, roughness:1, side:THREE.DoubleSide, emissive:0x2a2a26, emissiveIntensity:0.4
  }), 0, 1.72, 0, g);
  driftable(g, 0.19);
  var bulb = new THREE.PointLight(0xfff4e8, 0.27, 5.5, 2);
  bulb.position.set(0, 1.6, 0);
  g.add(bulb);
  blocker(-2.35, -2.35, 0.44, 0.44);
})();

/* ==========================================================================
   12 / FINESTRA E CITTÀ
   ========================================================================== */

(function windowAndCity(){
  var wx = HW, sillY = 1.02, winH = 1.72, winW = 2.7, winZ = -0.4;
  var APT = 42;   // quota dell'appartamento: il salotto sta in alto

  // ---- telaio -------------------------------------------------------------
  var fg = new THREE.Group();
  fg.position.set(wx - 0.06, sillY + winH/2, winZ);
  scene.add(fg);
  box(0.09, winH + 0.16, 0.1, M.ink, 0, 0, -winW/2 - 0.05, fg);
  box(0.09, winH + 0.16, 0.1, M.ink, 0, 0,  winW/2 + 0.05, fg);
  box(0.09, 0.1, winW + 0.2, M.ink, 0,  winH/2 + 0.05, 0, fg);
  box(0.09, 0.1, winW + 0.2, M.ink, 0, -winH/2 - 0.05, 0, fg);
  box(0.09, winH, 0.06, M.ink, 0, 0, 0, fg);
  box(0.09, 0.06, winW, M.ink, 0, 0, 0, fg);
  box(0.3, 0.06, winW + 0.3, M.paper, wx - 0.16, sillY - 0.06, winZ);

  // ---- orizzonte a 360 gradi ----------------------------------------------
  // La linea dell'orizzonte cade all'altezza dell'occhio: si guarda lo skyline
  // in faccia, non dal basso.
  var c = makeCanvas(2048, 700);
  var x = c.getContext("2d");
  var HZ = 350;                       // riga dell'orizzonte nel canvas
  var sky = x.createLinearGradient(0,0,0,HZ);
  sky.addColorStop(0.00, "#fdfdfc");
  sky.addColorStop(0.62, "#f3f1ec");
  sky.addColorStop(1.00, "#e8e6e0");
  x.fillStyle = sky; x.fillRect(0,0,2048,HZ);
  var below = x.createLinearGradient(0,HZ,0,700);
  below.addColorStop(0, "#e0ded8");
  below.addColorStop(1, "#cbc8c2");
  x.fillStyle = below; x.fillRect(0,HZ,2048,350);

  function skyline(count, minH, maxH, minW, maxW, tone, winAlpha, baseY){
    for (var i=0; i<count; i++){
      var bw = minW + Math.random()*(maxW-minW);
      var bh = minH + Math.random()*(maxH-minH);
      var bx = Math.random()*2048;
      x.fillStyle = tone;
      x.fillRect(bx, baseY-bh, bw, bh);
      if (Math.random() < 0.3)
        x.fillRect(bx + bw*0.35, baseY-bh-16-Math.random()*26, bw*0.28, 36);
      x.fillStyle = "rgba(244,242,238," + winAlpha + ")";
      for (var wy = baseY-bh+10; wy < baseY-6; wy += 14){
        for (var wxx = bx+5; wxx < bx+bw-8; wxx += 11){
          if (Math.random() < 0.5) x.fillRect(wxx, wy, 5, 6);
        }
      }
    }
  }
  skyline(110, 20, 110, 22, 54, "#dbd9d3", 0.26, HZ + 26);
  skyline( 80, 40, 170, 30, 70, "#c8c6c0", 0.34, HZ + 16);
  skyline( 52, 70, 240, 40, 88, "#b2b0aa", 0.40, HZ + 6);
  var horizonTex = canvasTexture(c);
  if (THREE.RepeatWrapping !== undefined){
    horizonTex.wrapS = THREE.RepeatWrapping;
    if (horizonTex.repeat && horizonTex.repeat.set) horizonTex.repeat.set(4, 1);
  }
  // altezza 100 con centro a y=1.6: la riga d'orizzonte del canvas cade a occhio
  var horizon = new THREE.Mesh(
    new THREE.CylinderGeometry(95, 95, 100, 48, 1, true),
    new THREE.MeshBasicMaterial({ map:horizonTex, side:THREE.BackSide })
  );
  horizon.position.set(0, 1.6, 0);
  scene.add(horizon);

  // ---- tutto il fuori sta 42 metri piu' in basso ---------------------------
  var outside = new THREE.Group();
  outside.position.y = -APT;
  scene.add(outside);

  // Nebbia in altezza. Ogni superficie esterna sfuma verso il bianco sotto una
  // certa quota, cosi la citta' non poggia su niente: emerge. E' un innesto nel
  // materiale, non un piano trasparente, quindi tiene da ogni punto di vista.
  var HF_TOP = -20;      // quota in cui la nebbia e' finita
  var HF_BOTTOM = -44;   // quota in cui copre tutto
  var HF_COLOR = new THREE.Color(C.white);
  if (HF_COLOR.convertSRGBToLinear) HF_COLOR.convertSRGBToLinear();

  function heightFog(material){
    material.onBeforeCompile = function(shader){
      shader.uniforms.hfTop = { value: HF_TOP };
      shader.uniforms.hfBottom = { value: HF_BOTTOM };
      shader.uniforms.hfColor = { value: HF_COLOR };
      shader.vertexShader =
        "varying float vWorldY;\n" +
        shader.vertexShader.replace(
          "#include <begin_vertex>",
          "#include <begin_vertex>\n  vWorldY = (modelMatrix * vec4(transformed, 1.0)).y;"
        );
      shader.fragmentShader =
        "varying float vWorldY;\nuniform float hfTop;\nuniform float hfBottom;\nuniform vec3 hfColor;\n" +
        shader.fragmentShader.replace(
          "#include <dithering_fragment>",
          "#include <dithering_fragment>\n" +
          "  float hf = 1.0 - smoothstep(hfBottom, hfTop, vWorldY);\n" +
          "  gl_FragColor.rgb = mix(gl_FragColor.rgb, hfColor, hf * hf);"
        );
    };
    material.customProgramCacheKey = function(){ return "utopia-heightfog"; };
    return material;
  }

  var ground = new THREE.Mesh(new THREE.PlaneGeometry(400, 400), heightFog(mat(0xc9c6bf, 1.0)));
  ground.rotation.x = -Math.PI/2;
  ground.position.y = -0.06;
  outside.add(ground);
  var road = new THREE.Mesh(new THREE.PlaneGeometry(11, 300), heightFog(mat(0x97958f, 1.0)));
  road.rotation.x = -Math.PI/2;
  road.position.set(HW + 11, -0.02, 0);
  outside.add(road);

  // ---- palazzi ------------------------------------------------------------
  // Le finestre sono dipinte nella texture, non sono mesh. Prima erano circa
  // seicento piani separati: su mobile il contesto WebGL saltava e restava
  // schermo nero. Geometrie e materiali qui sono condivisi.
  function facadeTexture(base, band){
    var fc = makeCanvas(128, 256);
    var f = fc.getContext("2d");
    f.fillStyle = base; f.fillRect(0,0,128,256);
    // cornicione scuro in cima, prima era una mesh a parte
    f.fillStyle = band; f.fillRect(0,0,128,14);
    for (var r=0; r<22; r++){
      for (var q=0; q<7; q++){
        var on = Math.random();
        f.fillStyle = on < 0.22 ? "rgba(244,242,238,0.85)"
                   : on < 0.55 ? "rgba(255,255,255,0.16)"
                               : "rgba(40,40,38,0.20)";
        f.fillRect(9 + q*16, 26 + r*10, 9, 6);
      }
    }
    var t = canvasTexture(fc);
    if (THREE.RepeatWrapping !== undefined){
      t.wrapS = THREE.RepeatWrapping; t.wrapT = THREE.RepeatWrapping;
    }
    return t;
  }
  var tones = [
    heightFog(new THREE.MeshStandardMaterial({ map:facadeTexture("#bebcb6","#6a6864"), roughness:0.95 })),
    heightFog(new THREE.MeshStandardMaterial({ map:facadeTexture("#aeaca6","#63615e"), roughness:0.95 })),
    heightFog(new THREE.MeshStandardMaterial({ map:facadeTexture("#9e9c97","#5c5a57"), roughness:0.95 })),
    heightFog(new THREE.MeshStandardMaterial({ map:facadeTexture("#8d8b86","#545250"), roughness:0.95 }))
  ];
  var dark = heightFog(mat(0x6a6864, 0.9));
  // Tetto: cemento liscio, senza finestre. Prima la texture di facciata
  // finiva anche sulla faccia superiore e da quassu' si vedeva.
  var roof = heightFog(mat(0x8a8883, 0.97));
  var UNIT = new THREE.BoxGeometry(1, 1, 1);   // una sola geometria per tutti
  // ordine facce BoxGeometry: +x, -x, +y (tetto), -y, +z, -z
  var faces = tones.map(function(t){ return [t, t, roof, roof, t, t]; });

  function building(bx, bz, bw, bd, bh, toneIdx){
    var b = new THREE.Mesh(UNIT, faces[toneIdx]);
    b.scale.set(bw, bh, bd);
    b.position.set(bx, bh/2, bz);
    outside.add(b);
    // solo volumi tecnici bassi sul tetto, nessun palo, nessuna antenna
    if (Math.random() < 0.4){
      var tw = bw*(0.2 + Math.random()*0.22);
      var th = 1.2 + Math.random()*1.8;
      var tech = new THREE.Mesh(UNIT, roof);   // volumi tecnici: niente finestre
      tech.scale.set(tw, th, tw);
      tech.position.set(bx + (Math.random()-0.5)*bw*0.35,
                        bh + 0.5 + th/2 - 0.1,                 // poggia sul cornicione
                        bz + (Math.random()-0.5)*bd*0.35);
      outside.add(tech);
    }
    // cornicione scuro: stacca il tetto dal cielo chiaro. Appoggiato SOPRA
    // il tetto (da bh a bh+0.5) e non piu' a cavallo: prima la sua faccia
    // superiore coincideva col tetto e su molti telefoni (profondita' a
    // 16 bit) le due facce sfarfallavano a righe.
    var cap = new THREE.Mesh(UNIT, dark);
    cap.scale.set(bw*1.03, 0.5, bd*1.03);
    cap.position.set(bx, bh + 0.25, bz);
    outside.add(cap);
  }

  // Isolati su griglia con scarto controllato. Prima erano piazzati a caso e
  // si compenetravano fra loro: da qui l'impasto illeggibile.
  var bands = [
    { x:HW + 20, cell:26, foot:[10, 17], h:[16, 46] },
    { x:HW + 46, cell:30, foot:[11, 19], h:[20, 58] },
    { x:HW + 76, cell:34, foot:[13, 22], h:[24, 70] },
    { x:HW + 112, cell:40, foot:[15, 26], h:[28, 84] }
  ];
  bands.forEach(function(band, bi){
    var half = 150;
    for (var z = -half; z <= half; z += band.cell){
      if (Math.random() < 0.12) continue;              // qualche lotto vuoto
      // la prima fascia lascia libero il lotto delle due torri ravvicinate
      if (bi === 0 && (Math.abs(z + 26) < 22 || Math.abs(z - 24) < 22)) continue;
      var fw = band.foot[0] + Math.random()*(band.foot[1] - band.foot[0]);
      var fd = band.foot[0] + Math.random()*(band.foot[1] - band.foot[0]);
      var slack = band.cell - Math.max(fw, fd) - 6;    // margine di strada
      var jx = (Math.random() - 0.5) * Math.max(0, slack);
      var jz = (Math.random() - 0.5) * Math.max(0, slack);
      var bh = band.h[0] + Math.random()*(band.h[1] - band.h[0]);
      building(band.x + jx, z + jz, fw, fd, bh, Math.min(3, bi + (Math.random() < 0.5 ? 0 : 1)));
    }
  });

  // le due torri vicine danno la misura dell'altezza dell'appartamento
  building(HW + 13, -26, 13, 13, 68, 1);
  building(HW + 15,  24, 11, 15, 54, 0);

  // ---- droni: telecamere volanti ------------------------------------------
  // Corpo, pattini, quattro motori con rotori sfocati e una testa su cardano
  // che ruota per conto suo. Geometrie e materiali condivisi da tutti.
  var shell  = new THREE.MeshStandardMaterial({ color:0x24242a, roughness:0.5,  metalness:0.3 });
  var shell2 = new THREE.MeshStandardMaterial({ color:0x17171b, roughness:0.65, metalness:0.2 });
  var glassM = new THREE.MeshStandardMaterial({ color:0x07070a, roughness:0.06, metalness:0.8 });
  var ringM  = new THREE.MeshStandardMaterial({ color:0x8f8f8a, roughness:0.3,  metalness:0.7 });
  var ledM   = new THREE.MeshBasicMaterial({ color:C.red });

  var rotorTex = (function(){
    var rc = makeCanvas(128, 128);
    var r = rc.getContext("2d");
    // due archi sovrapposti: la pala non si ferma mai, si legge la scia
    for (var p2=0; p2<2; p2++){
      r.strokeStyle = "rgba(28,28,32," + (0.3 - p2*0.13) + ")";
      r.lineWidth = 16 - p2*7;
      r.beginPath();
      r.arc(64, 64, 44 - p2*11, p2*1.2, p2*1.2 + Math.PI*1.55);
      r.stroke();
    }
    var g1 = r.createRadialGradient(64, 64, 8, 64, 64, 60);
    g1.addColorStop(0.00, "rgba(30,30,34,0.34)");
    g1.addColorStop(0.72, "rgba(30,30,34,0.10)");
    g1.addColorStop(1.00, "rgba(30,30,34,0.0)");
    r.fillStyle = g1;
    r.beginPath(); r.arc(64, 64, 62, 0, Math.PI*2); r.fill();
    r.fillStyle = "rgba(20,20,24,0.9)";
    r.beginPath(); r.arc(64, 64, 8, 0, Math.PI*2); r.fill();
    return canvasTexture(rc);
  })();
  var rotorMat = new THREE.MeshBasicMaterial({ map:rotorTex, transparent:true, depthWrite:false });

  var G = {
    body:  new THREE.BoxGeometry(0.30, 0.15, 0.46),
    belly: new THREE.BoxGeometry(0.23, 0.06, 0.32),
    arm:   new THREE.BoxGeometry(0.98, 0.036, 0.055),
    pod:   new THREE.CylinderGeometry(0.045, 0.052, 0.09, 8),
    skid:  new THREE.BoxGeometry(0.026, 0.026, 0.34),
    strut: new THREE.BoxGeometry(0.024, 0.11, 0.024),
    yoke:  new THREE.BoxGeometry(0.15, 0.09, 0.04),
    head:  new THREE.BoxGeometry(0.15, 0.13, 0.13),
    lens:  new THREE.CylinderGeometry(0.058, 0.068, 0.09, 12),
    ring:  new THREE.CylinderGeometry(0.070, 0.070, 0.014, 12),
    led:   new THREE.BoxGeometry(0.028, 0.028, 0.018),
    rotor: new THREE.PlaneGeometry(0.46, 0.46)
  };

  // Corridoi liberi fra le file di palazzi (distanza dal muro della
  // finestra): i droni volano solo qui, prima attraversavano gli edifici.
  // Calcolati sull'ingombro massimo di ogni fila, jitter compreso.
  var LANES = [3.5, 32, 60, 92.5];
  window.__drones = [];
  for (var d=0; d<18; d++){
    var far = Math.random();
    var full = far < 0.32;          // solo i vicini montano tutto
    var dg = new THREE.Group();

    dg.add(new THREE.Mesh(G.body, shell));
    dg.add((function(){ var m2 = new THREE.Mesh(G.belly, shell2); m2.position.y = -0.09; return m2; })());

    var rot = [];
    // Telaio a X con quattro rotori agli angoli. Questo lo montano tutti,
    // vicini e lontani: e' la sagoma che li fa leggere come droni.
    for (var arm=0; arm<2; arm++){
      var am = new THREE.Mesh(G.arm, shell2);
      am.rotation.y = (arm ? -1 : 1) * Math.PI/4;
      am.position.y = 0.075;
      dg.add(am);
    }
    for (var q=0; q<4; q++){
      var ang = Math.PI/4 + q*Math.PI/2;
      var ex = Math.cos(ang)*0.49, ez = Math.sin(ang)*0.49;
      if (full){
        var pod = new THREE.Mesh(G.pod, shell);
        pod.position.set(ex, 0.1, ez);
        dg.add(pod);
      }
      var rr = new THREE.Mesh(G.rotor, rotorMat);
      rr.rotation.x = -Math.PI/2;
      rr.position.set(ex, 0.16, ez);
      dg.add(rr);
      rot.push(rr);
    }

    if (full){
      // pattini di atterraggio, solo da vicino
      for (var sk=0; sk<2; sk++){
        var sx = (sk ? 1 : -1) * 0.11;
        var sm = new THREE.Mesh(G.skid, shell2);
        sm.position.set(sx, -0.19, 0.02);
        dg.add(sm);
        var st = new THREE.Mesh(G.strut, shell2);
        st.position.set(sx, -0.14, 0.02);
        dg.add(st);
      }
    }

    // testa su cardano: pende davanti e ruota indipendente dal corpo
    var yoke = new THREE.Mesh(G.yoke, shell2);
    yoke.position.set(0, -0.13, 0.18);
    dg.add(yoke);

    var head = new THREE.Group();
    head.position.set(0, -0.2, 0.18);
    dg.add(head);
    head.add(new THREE.Mesh(G.head, shell));
    var lens = new THREE.Mesh(G.lens, glassM);
    lens.rotation.x = Math.PI/2;
    lens.position.z = 0.1;
    head.add(lens);
    var ring = new THREE.Mesh(G.ring, ringM);
    ring.rotation.x = Math.PI/2;
    ring.position.z = 0.142;
    head.add(ring);

    // strobo di segnalazione
    var led = new THREE.Mesh(G.led, ledM);
    led.position.set(0, -0.115, -0.2);
    dg.add(led);

    dg.position.set(HW + LANES[Math.min(3, Math.floor(far*4))] + (Math.random()-0.5)*0.8,
                    -26 + Math.random()*40,
                    -60 + Math.random()*120);
    var k = 1 + far*1.1;
    dg.scale.set(k, k, k);
    dg.userData = {
      ph: Math.random()*6.28,
      bob: 0.14 + Math.random()*0.3,
      base: dg.position.y,
      cruise: (Math.random() < 0.5 ? -1 : 1) * (0.3 + Math.random()*0.9),
      hover: Math.random()*14,       // ogni tanto si ferma e guarda
      scanning: false,
      rot: rot,
      head: head,
      led: led,
      blink: 0.9 + Math.random()*1.4
    };
    scene.add(dg);
    window.__drones.push(dg);
  }

  // ---- velature di nebbia --------------------------------------------------
  // Pochi veli verticali sempre rivolti verso chi guarda. I piani orizzontali
  // da questa quota si vedevano di taglio e sparivano: da qui l'effetto nullo.
  var cloudTex = (function(){
    var cc = makeCanvas(256, 256);
    var q = cc.getContext("2d");
    for (var i=0; i<14; i++){
      var cx = 40 + Math.random()*176;
      var cy = 96 + Math.random()*104;
      var rr = 30 + Math.random()*70;
      var g2 = q.createRadialGradient(cx, cy, 0, cx, cy, rr);
      g2.addColorStop(0.0, "rgba(255,255,255,0.62)");
      g2.addColorStop(0.5, "rgba(251,250,247,0.26)");
      g2.addColorStop(1.0, "rgba(246,245,241,0.0)");
      q.fillStyle = g2;
      q.beginPath(); q.arc(cx, cy, rr, 0, Math.PI*2); q.fill();
    }
    q.globalCompositeOperation = "destination-out";
    var e1 = q.createLinearGradient(0, 0, 0, 256);
    e1.addColorStop(0.0, "rgba(0,0,0,1)"); e1.addColorStop(0.3, "rgba(0,0,0,0)");
    e1.addColorStop(0.72, "rgba(0,0,0,0)"); e1.addColorStop(1.0, "rgba(0,0,0,1)");
    q.fillStyle = e1; q.fillRect(0, 0, 256, 256);
    var e2 = q.createLinearGradient(0, 0, 256, 0);
    e2.addColorStop(0.0, "rgba(0,0,0,1)"); e2.addColorStop(0.18, "rgba(0,0,0,0)");
    e2.addColorStop(0.82, "rgba(0,0,0,0)"); e2.addColorStop(1.0, "rgba(0,0,0,1)");
    q.fillStyle = e2; q.fillRect(0, 0, 256, 256);
    q.globalCompositeOperation = "source-over";
    return canvasTexture(cc);
  })();

  var cloudGeo = new THREE.PlaneGeometry(1, 1);
  window.__clouds = [];
  for (var n2=0; n2<9; n2++){
    var lay = n2 / 9;
    var cm = new THREE.Mesh(cloudGeo, new THREE.MeshBasicMaterial({
      map: cloudTex,
      transparent: true,
      depthWrite: false,
      opacity: 0.2 + Math.random()*0.2,
      color: 0xfcfbf8,
      fog: false
    }));
    var w2 = 130 + Math.random()*150;
    cm.scale.set(w2, w2*0.34, 1);
    cm.position.set(HW + 24 + lay*96 + (Math.random()-0.5)*36,
                    9 + Math.random()*12,
                    -120 + Math.random()*240);
    cm.renderOrder = 2;
    outside.add(cm);
    window.__clouds.push({
      m: cm,
      sp: 0.3 + Math.random()*0.8,
      ph: Math.random()*6.28,
      op: cm.material.opacity
    });
  }
})();

/* ==========================================================================
   13 / I CINQUE CD APPESI
   ========================================================================== */

// Un jewel case reale misura 142 mm. Qui 0.30 m: leggibile come opera,
// ancora inequivocabilmente un CD e non una stampa incorniciata.
var CD_SIZE = 0.30;
var CD_OFFSET = 0.045;   // distacco dalla parete

function hangCD(product, idx, wallAxis, wallSign, along, height){
  var g = new THREE.Group();
  if (wallAxis === "z"){
    g.position.set(along, height, wallSign * HD - wallSign * CD_OFFSET);
    g.rotation.y = wallSign > 0 ? Math.PI : 0;
  } else {
    g.position.set(wallSign * HW - wallSign * CD_OFFSET, height, along);
    g.rotation.y = wallSign > 0 ? -Math.PI/2 : Math.PI/2;
  }
  scene.add(g);

  // ombra portata sulla parete
  var sc = makeCanvas(128,128);
  var sx = sc.getContext("2d");
  var grad = sx.createRadialGradient(64,64,10, 64,64,64);
  grad.addColorStop(0, "rgba(20,20,20,0.34)");
  grad.addColorStop(1, "rgba(20,20,20,0)");
  sx.fillStyle = grad; sx.fillRect(0,0,128,128);
  var shadow = new THREE.Mesh(new THREE.PlaneGeometry(CD_SIZE*1.9, CD_SIZE*1.9),
    new THREE.MeshBasicMaterial({ map:new THREE.CanvasTexture(sc), transparent:true, depthWrite:false }));
  shadow.position.set(0.02, -0.02, -CD_OFFSET + 0.004);
  g.add(shadow);

  // supporto a muro
  var bracket = cyl(0.008, 0.008, CD_OFFSET, 8, M.chrome, 0, 0, -CD_OFFSET/2, g);
  bracket.rotation.x = Math.PI/2;
  var plate = cyl(0.016, 0.016, 0.005, 10, M.chrome, 0, 0, -CD_OFFSET + 0.003, g);
  plate.rotation.x = Math.PI/2;

  // retro custodia
  box(CD_SIZE, CD_SIZE, 0.014, mat(0x1a1a1a, 0.55), 0, 0, -0.007, g);

  // copertina
  var tex = coverTexture(product, idx);
  var cover = new THREE.Mesh(new THREE.PlaneGeometry(CD_SIZE*0.955, CD_SIZE*0.955),
    new THREE.MeshStandardMaterial({ map:tex, roughness:0.5, metalness:0.03 }));
  cover.position.set(0, 0, 0.0008);
  cover.castShadow = false;
  g.add(cover);
  useCover(idx, cover);

  // vetro della custodia, con riflesso
  var jewel = new THREE.Mesh(new THREE.BoxGeometry(CD_SIZE*1.005, CD_SIZE*1.005, 0.012),
    new THREE.MeshStandardMaterial({
      color:0xffffff, roughness:0.05, metalness:0.0,
      transparent:true, opacity:0.2, side:THREE.DoubleSide
    }));
  jewel.position.set(0, 0, 0.008);
  g.add(jewel);
  // striscia di riflesso diagonale
  var refl = new THREE.Mesh(new THREE.PlaneGeometry(CD_SIZE*0.28, CD_SIZE*1.4),
    new THREE.MeshBasicMaterial({ color:0xffffff, transparent:true, opacity:0.1, depthWrite:false }));
  refl.position.set(-CD_SIZE*0.2, 0, 0.0145);
  refl.rotation.z = 0.5;
  g.add(refl);

  // cartellino, minuscolo, tipografia di sala
  var lc = makeCanvas(256, 96);
  var lx = lc.getContext("2d");
  lx.fillStyle = "#f4f2ee"; lx.fillRect(0,0,256,96);
  lx.fillStyle = "#141414";
  lx.font = "700 20px 'Courier New', monospace";
  lx.fillText(product.code, 8, 28);
  lx.fillStyle = "#8f8f8a";
  lx.font = "16px 'Courier New', monospace";
  lx.fillText(product.name.slice(0,20), 8, 52);
  lx.fillStyle = "#c81414"; lx.fillRect(8, 62, 40, 3);
  lx.fillStyle = "#8f8f8a";
  lx.font = "13px 'Courier New', monospace";
  lx.fillText("ED. " + product.edition, 8, 84);
  var label = new THREE.Mesh(new THREE.PlaneGeometry(0.16, 0.06),
    new THREE.MeshBasicMaterial({ map:canvasTexture(lc) }));
  label.position.set(CD_SIZE*0.5 + 0.11, -CD_SIZE*0.34, -CD_OFFSET + 0.006);
  g.add(label);

  // superficie di click generosa, invisibile
  var hit = new THREE.Mesh(new THREE.PlaneGeometry(CD_SIZE*1.5, CD_SIZE*1.5),
    new THREE.MeshBasicMaterial({ visible:false }));
  hit.position.set(0, 0, 0.02);
  g.add(hit);
  interactive(hit, "product", product, product.code + " / " + product.name);

  // il disco puo' scivolare lungo la parete e in altezza, mai dentro il muro
  driftable(g, 0.13, wallAxis === "x" ? ["z", "y"] : ["x", "y"]);

  return g;
}

// composizione: tre sulla parete ovest, sfalsate; due sulla parete nord
hangCD(PRODUCTS[0], 0, "x", -1, -2.50, 1.66);
hangCD(PRODUCTS[1], 1, "x", -1, -1.35, 1.42);
hangCD(PRODUCTS[2], 2, "x", -1, -0.20, 1.70);
hangCD(PRODUCTS[3], 3, "z", -1, -2.45, 1.74);
hangCD(PRODUCTS[4], 4, "z", -1,  2.45, 1.50);

/* ==========================================================================
   14 / AUDIO
   ========================================================================== */

var Audio_ = (function(){
  var ctx = null, master = null, on = true, started = false;
  var hum = null;

  function ensure(){
    // Ingresso automatico (gia' iscritti): il contesto nasce sospeso perche'
    // non c'e' stato un gesto. Il primo tocco o click lo riprende.
    if (started){ if (ctx && ctx.state === "suspended" && ctx.resume) ctx.resume(); return; }
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    ctx = new AC();
    master = ctx.createGain();
    master.gain.value = 0.55;
    master.connect(ctx.destination);
    started = true;
    roomTone();
    tvHum();
    neighbour();
  }
  function noiseBuffer(sec){
    var b = ctx.createBuffer(1, ctx.sampleRate*sec, ctx.sampleRate);
    var d = b.getChannelData(0);
    for (var i=0;i<d.length;i++) d[i] = Math.random()*2-1;
    return b;
  }
  function roomTone(){
    var src = ctx.createBufferSource();
    src.buffer = noiseBuffer(3); src.loop = true;
    var f = ctx.createBiquadFilter();
    f.type = "lowpass"; f.frequency.value = 180;
    var g = ctx.createGain(); g.gain.value = 0.035;
    src.connect(f); f.connect(g); g.connect(master);
    src.start();
  }
  function tvHum(){
    var panner = ctx.createPanner();
    panner.panningModel = "HRTF";
    panner.distanceModel = "inverse";
    panner.refDistance = 1.6; panner.maxDistance = 14; panner.rolloffFactor = 1.6;
    if (panner.positionX){
      panner.positionX.value = 0; panner.positionY.value = 1.3; panner.positionZ.value = -3.2;
    } else panner.setPosition(0, 1.3, -3.2);
    panner.connect(master);

    var osc = ctx.createOscillator();
    osc.type = "sine"; osc.frequency.value = 61;
    var og = ctx.createGain(); og.gain.value = 0.05;
    osc.connect(og); og.connect(panner); osc.start();

    var src = ctx.createBufferSource();
    src.buffer = noiseBuffer(2); src.loop = true;
    var bp = ctx.createBiquadFilter();
    bp.type = "bandpass"; bp.frequency.value = 5200; bp.Q.value = 1.6;
    var ng = ctx.createGain(); ng.gain.value = 0.02;
    src.connect(bp); bp.connect(ng); ng.connect(panner); src.start();
    hum = { panner:panner, gain:og };
  }
  // Il televisore del vicino. Non lo vedi mai. Voci indistinte attraverso il
  // muro ovest: due muri di filtro passa basso, nessuna parola riconoscibile.
  function neighbour(){
    var panner = ctx.createPanner();
    panner.panningModel = "HRTF";
    panner.distanceModel = "inverse";
    panner.refDistance = 2.2; panner.maxDistance = 22; panner.rolloffFactor = 1.1;
    var px = -(ROOM.w/2) - 1.7, py = 1.25, pz = 1.4;
    if (panner.positionX){
      panner.positionX.value = px; panner.positionY.value = py; panner.positionZ.value = pz;
    } else panner.setPosition(px, py, pz);
    panner.connect(master);

    // il muro
    var w1 = ctx.createBiquadFilter(); w1.type = "lowpass"; w1.frequency.value = 340; w1.Q.value = 0.7;
    var w2 = ctx.createBiquadFilter(); w2.type = "lowpass"; w2.frequency.value = 620;
    var out = ctx.createGain(); out.gain.value = 0.0;
    w1.connect(w2); w2.connect(out); out.connect(panner);

    // brusio del loro apparecchio
    var nz = ctx.createBufferSource();
    nz.buffer = noiseBuffer(3); nz.loop = true;
    var ng = ctx.createGain(); ng.gain.value = 0.02;
    nz.connect(ng); ng.connect(w1); nz.start();

    // voci: due sorgenti glottali dentro due formanti mobili
    var v1 = ctx.createOscillator(); v1.type = "sawtooth"; v1.frequency.value = 112;
    var v2 = ctx.createOscillator(); v2.type = "sawtooth"; v2.frequency.value = 94;
    var f1 = ctx.createBiquadFilter(); f1.type = "bandpass"; f1.frequency.value = 620; f1.Q.value = 6;
    var f2 = ctx.createBiquadFilter(); f2.type = "bandpass"; f2.frequency.value = 1180; f2.Q.value = 9;
    var vg = ctx.createGain(); vg.gain.value = 0;
    v1.connect(f1); v2.connect(f1); v1.connect(f2); v2.connect(f2);
    f1.connect(vg); f2.connect(vg); vg.connect(w1);
    v1.start(); v2.start();

    function ramp(p, val, when, tau){
      if (p.setTargetAtTime) p.setTargetAtTime(val, when, tau);
      else if (p.setValueAtTime) p.setValueAtTime(val, when);
      else p.value = val;
    }
    ramp(out.gain, 0.13, ctx.currentTime, 3);

    // una battuta: da due a otto sillabe, poi silenzio di lunghezza variabile
    function speak(){
      var t = ctx.currentTime + 0.05;
      var t0 = t;
      var n = 2 + Math.floor(Math.random()*7);
      for (var i=0; i<n; i++){
        var d = 0.08 + Math.random()*0.17;
        ramp(vg.gain, 0.05 + Math.random()*0.05, t, 0.018);
        ramp(vg.gain, 0.0, t + d, 0.045);
        ramp(v1.frequency, 94 + Math.random()*58, t, 0.05);
        ramp(v2.frequency, 78 + Math.random()*48, t, 0.05);
        ramp(f1.frequency, 420 + Math.random()*440, t, 0.035);
        ramp(f2.frequency, 940 + Math.random()*760, t, 0.035);
        t += d + 0.03 + Math.random()*0.1;
      }
      setTimeout(speak, (t - t0)*1000 + 900 + Math.random()*4200);
    }
    setTimeout(speak, 2200);
  }

  function blip(freq, dur, type, vol){
    if (!ctx || !on) return;
    var o = ctx.createOscillator(), g = ctx.createGain();
    o.type = type || "square"; o.frequency.value = freq;
    g.gain.setValueAtTime(vol || 0.06, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + dur);
    o.connect(g); g.connect(master);
    o.start(); o.stop(ctx.currentTime + dur);
  }
  return {
    start: ensure,
    click: function(){ blip(1400, 0.05, "square", 0.05); blip(700, 0.07, "square", 0.03); },
    clunk: function(){ blip(120, 0.16, "sawtooth", 0.09); blip(70, 0.3, "sine", 0.07); },
    tick:  function(){ blip(2200, 0.02, "square", 0.018); },
    tear:  function(){ blip(2600, 0.035, "square", 0.03); blip(140, 0.09, "sawtooth", 0.045); },
    toggle: function(){
      on = !on;
      if (master) master.gain.value = on ? 0.55 : 0.0;
      return on;
    },
    listener: function(cam){
      if (!ctx || !ctx.listener) return;
      var L = ctx.listener;
      var p = cam.position;
      if (L.positionX){
        L.positionX.value = p.x; L.positionY.value = p.y; L.positionZ.value = p.z;
      } else if (L.setPosition) L.setPosition(p.x, p.y, p.z);
      var dir = new THREE.Vector3();
      cam.getWorldDirection(dir);
      if (L.forwardX){
        L.forwardX.value = dir.x; L.forwardY.value = dir.y; L.forwardZ.value = dir.z;
        L.upX.value = 0; L.upY.value = 1; L.upZ.value = 0;
      } else if (L.setOrientation) L.setOrientation(dir.x, dir.y, dir.z, 0, 1, 0);
    }
  };
})();

var muteBtn = document.getElementById("mute");
muteBtn.addEventListener("click", function(e){
  e.stopPropagation();
  var on = Audio_.toggle();
  muteBtn.classList.toggle("off", !on);
});

/* ==========================================================================
   15 / CONTROLLI
   ========================================================================== */

var isTouch = ("ontouchstart" in window) || navigator.maxTouchPoints > 0;
if (isTouch) document.body.classList.add("touch");

// Stato della stanza: finche' non si entra (e mentre pannello o conferma
// di uscita sono aperti) niente sguardo, niente movimento, niente joystick.
var entered = false;
function uiOpen(){
  return document.getElementById("panel").style.display === "block" ||
         document.getElementById("exit-confirm").classList.contains("show");
}
function syncStick(){
  var z = document.getElementById("stickzone");
  if (z) z.style.visibility = (entered && !uiOpen()) ? "visible" : "hidden";
}

var keys = {};
window.addEventListener("keydown", function(e){
  // niente movimento mentre si scrive l'email
  if (e.target && /^(INPUT|TEXTAREA)$/.test(e.target.tagName)) return;
  keys[e.code] = true;
});
window.addEventListener("keyup", function(e){ keys[e.code] = false; });

var yaw = 0, pitch = 0;
var lookId = null, lookX = 0, lookY = 0, moved = 0, downT = 0;
var pointerX = 0, pointerY = 0;

var el = renderer.domElement;

el.addEventListener("pointerdown", function(e){
  if (!entered || uiOpen()) return;
  lookId = e.pointerId;
  lookX = e.clientX; lookY = e.clientY;
  moved = 0; downT = performance.now();
  Audio_.start();
});
el.addEventListener("pointermove", function(e){
  pointerX = (e.clientX / window.innerWidth) * 2 - 1;
  pointerY = -(e.clientY / window.innerHeight) * 2 + 1;
  if (lookId === null || e.pointerId !== lookId) return;
  var dx = e.clientX - lookX, dy = e.clientY - lookY;
  lookX = e.clientX; lookY = e.clientY;
  moved += Math.abs(dx) + Math.abs(dy);
  // Al tocco si "trascina il mondo" (come Street View): dito a destra =
  // sguardo a sinistra. Col mouse resta come prima.
  var dir = e.pointerType === "touch" ? -1 : 1;
  yaw -= dir * dx * 0.0032;
  pitch -= dir * dy * 0.0028;
  pitch = Math.max(-1.1, Math.min(1.1, pitch));
});
el.addEventListener("pointerup", function(e){
  if (lookId !== null && e.pointerId === lookId){
    var quick = performance.now() - downT < 420;
    if (moved < 9 && quick) tryInteract(e.clientX, e.clientY);
    lookId = null;
  }
});
el.addEventListener("pointercancel", function(){ lookId = null; });

// Joystick fisso in basso a sinistra, identico a quello delle Stanze 01 e 02:
// stesso posto, stesse dimensioni, si vede sempre (su touch, dopo l'ingresso).
var zone = document.getElementById("stickzone");
var knobEl = document.getElementById("stickKnob");
var MAXR = 40;        // corsa in px
var DEAD = 0.14;      // zona morta, evita la deriva involontaria
var stickId = null, stickVec = { x:0, y:0 };

function placeKnob(dx, dy){ knobEl.style.transform = "translate(" + dx + "px," + dy + "px)"; }

function stickStart(e){
  if (stickId !== null) return;
  e.preventDefault();
  stickId = e.pointerId;
  try { zone.setPointerCapture(e.pointerId); } catch(err){}
  zone.classList.add("active");
  Audio_.start();
  stickMove(e);
}
function stickMove(e){
  if (stickId === null || e.pointerId !== stickId) return;
  e.preventDefault();
  var r = zone.getBoundingClientRect();
  var dx = e.clientX - (r.left + r.width/2);
  var dy = e.clientY - (r.top + r.height/2);
  var len = Math.hypot(dx, dy);
  if (len > MAXR){ dx = dx/len*MAXR; dy = dy/len*MAXR; len = MAXR; }
  placeKnob(dx, dy);
  var nx = dx/MAXR, ny = dy/MAXR;
  var mag = Math.hypot(nx, ny);
  if (mag < DEAD){ stickVec.x = 0; stickVec.y = 0; return; }
  var scaled = (mag - DEAD) / (1 - DEAD);
  stickVec.x = nx/mag * scaled;
  stickVec.y = ny/mag * scaled;
}
function stickEnd(e){
  if (stickId === null) return;
  if (e && e.pointerId !== undefined && e.pointerId !== stickId) return;
  try { zone.releasePointerCapture(stickId); } catch(err){}
  stickId = null; stickVec.x = 0; stickVec.y = 0;
  placeKnob(0, 0);
  zone.classList.remove("active");
}
zone.addEventListener("pointerdown", stickStart);
zone.addEventListener("pointermove", stickMove);
zone.addEventListener("pointerup", stickEnd);
zone.addEventListener("pointercancel", stickEnd);
zone.addEventListener("lostpointercapture", stickEnd);
// rete di sicurezza: se il browser si mangia l'evento la camera non parte da sola
window.addEventListener("pointerup", stickEnd);
window.addEventListener("blur", function(){ stickEnd(); });
// blocco esplicito dello scroll nativo sotto il pollice
zone.addEventListener("touchstart", function(e){ e.preventDefault(); }, { passive:false });
zone.addEventListener("touchmove", function(e){ e.preventDefault(); }, { passive:false });

/* ==========================================================================
   16 / INTERAZIONE
   ========================================================================== */

var raycaster = new THREE.Raycaster();
var hintEl = document.getElementById("hint");
var hovered = null;

function pickAt(nx, ny){
  raycaster.setFromCamera({ x:nx, y:ny }, camera);
  var hits = raycaster.intersectObjects(INTERACTIVE, false);
  for (var i=0; i<hits.length; i++){
    if (hits[i].distance <= REACH) return hits[i].object;
  }
  return null;
}

function tryInteract(cx, cy){
  var nx = (cx / window.innerWidth) * 2 - 1;
  var ny = -(cy / window.innerHeight) * 2 + 1;
  var obj = pickAt(nx, ny);
  if (!obj) return;
  var k = obj.userData.kind;
  if (k === "product") openPanel(obj.userData.payload);
  else if (k === "tv" || k === "remote") setChannel(TV.channel + 1);
  else if (k === "vhs") toggleVHS();
}

function updateHover(){
  var nx = isTouch ? 0 : pointerX;
  var ny = isTouch ? 0 : pointerY;
  var obj = pickAt(nx, ny);
  if (obj !== hovered){
    hovered = obj;
    if (obj){
      hintEl.textContent = obj.userData.label || "";
      hintEl.classList.add("on");
    } else {
      hintEl.classList.remove("on");
    }
  }
}

/* ==========================================================================
   17 / PANNELLO PRODOTTO
   ========================================================================== */

var panel = document.getElementById("panel");
var addBtn = document.getElementById("panelAdd");
var cartLink = document.getElementById("panelCart");
var current = null;
function openPanel(p){
  current = p;
  var avail = p.available !== false;
  document.getElementById("panelTitle").textContent = p.code + ".exe";
  var img = document.getElementById("panelImg");
  if (p.img){ img.src = p.img; img.alt = p.name + " / " + p.sub; img.style.display = "block"; }
  else img.style.display = "none";
  document.getElementById("panelName").textContent = p.name + " / " + p.sub;
  document.getElementById("panelMeta").textContent =
    "HITLIST UTOPIA // CD // EDITION OF " + p.edition +
    (p.tracked !== false ? " // " + (avail ? p.left + " LEFT" : "SOLD OUT") : "");
  document.getElementById("panelPrice").textContent = "€ " + p.price;
  document.getElementById("panelLink").href = "/products/" + p.handle;
  addBtn.disabled = !avail || !p.variantId;
  addBtn.textContent = avail ? "ADD TO CART" : "SOLD OUT";
  cartLink.hidden = true;
  panel.style.display = "block";
  syncStick();
  Audio_.click();
}
function closePanel(){
  panel.style.display = "none";
  syncStick();
}
document.getElementById("panelClose").addEventListener("click", closePanel);

// Aggiunta diretta al carrello (Shopify AJAX API), come nelle altre stanze.
addBtn.addEventListener("click", function(){
  if (!current || !current.variantId || addBtn.disabled) return;
  var label = addBtn.textContent, ok = false;
  addBtn.disabled = true;
  addBtn.textContent = "ADDING...";
  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: [{ id: Number(current.variantId), quantity: 1 }] })
  }).then(function(r){
    if (!r.ok) throw new Error("status " + r.status);
    ok = true;
    addBtn.textContent = "ADDED";
    cartLink.hidden = false;
    Audio_.clunk();
  }).catch(function(err){
    if (window.console) console.error("Errore aggiunta al carrello:", err);
    addBtn.textContent = "ERROR - TRY AGAIN";
  }).then(function(){
    setTimeout(function(){
      addBtn.disabled = false;
      addBtn.textContent = ok ? "ADD ANOTHER" : label;
    }, 1600);
  });
});

// --- uscita -----------------------------------------------------------------
var exitBox = document.getElementById("exit-confirm");
function openExit(){ exitBox.classList.add("show"); syncStick(); Audio_.click(); }
function closeExit(){ exitBox.classList.remove("show"); syncStick(); }
document.getElementById("exitBtn").addEventListener("click", function(e){ e.stopPropagation(); openExit(); });
document.getElementById("exitStay").addEventListener("click", closeExit);
document.getElementById("exitGo").addEventListener("click", function(){
  window.location.href = (window.ROOM03_EXIT_URL || "/pages/utopia-rooms");
});
window.addEventListener("keydown", function(e){
  if (e.code === "Escape"){ closePanel(); closeExit(); }
});
// tornando indietro dalla scheda prodotto la pagina puo' riapparire dalla
// cache del browser con il pannello aperto: lo richiudiamo
window.addEventListener("pageshow", function(e){ if (e.persisted){ closePanel(); closeExit(); } });

/* ==========================================================================
   18 / ENTRATA
   ========================================================================== */

var entry = document.getElementById("entry");
var entryForm = document.getElementById("entry-form");

// Ingresso condiviso fra tutte le stanze Utopia: chi si e' iscritto in una
// stanza entra direttamente anche nelle altre (stesse chiavi delle 01 e 02).
var ENTRY_KEY = "utopia_room03_entered";
var SHARED_KEY = "utopia_entered";
var ALL_KEYS = [SHARED_KEY, "utopia_room01_entered", "utopia_room02_entered", ENTRY_KEY];
function rememberEntry(){
  try { localStorage.setItem(SHARED_KEY, "1"); localStorage.setItem(ENTRY_KEY, "1"); } catch (err){}
}
function hasEntered(){
  try {
    for (var i=0; i<ALL_KEYS.length; i++) if (localStorage.getItem(ALL_KEYS[i]) === "1") return true;
  } catch (err){}
  return false;
}
function enterRoom(){
  if (entered) return;
  entered = true;
  if (entry) entry.style.display = "none";
  Audio_.start();
  setChannel(0);
  syncStick();
}
syncStick();

// Invio nativo del form: e' l'unico modo che passa hCaptcha di Shopify e la
// politica frame-ancestors. Niente fetch, niente iframe. Shopify rimanda qui
// con ?entered=1 e la stanza si apre da sola.
function submitGate(){
  var field = document.getElementById("entry-email");
  var value = field ? String(field.value || "").trim() : "";
  var valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  if (!valid){
    if (field){
      field.classList.add("bad");
      field.focus();
      setTimeout(function(){ field.classList.remove("bad"); }, 1400);
    }
    return;
  }
  // L'ingresso si ricorda gia' qui, prima dell'invio: se il ritorno da
  // Shopify perde ?entered=1 (captcha, email gia' iscritta) alla visita
  // dopo si entra comunque senza rifare il modulo.
  rememberEntry();
  if (entryForm && entryForm.getAttribute("action")){
    var btn0 = document.getElementById("entryEnter");
    if (btn0){ btn0.disabled = true; btn0.textContent = "ENTERING..."; }
    entryForm.submit();   // la pagina naviga verso Shopify e torna qui
    return;
  }
  enterRoom();            // file locale, nessun form Shopify collegato
}

document.getElementById("entryEnter").addEventListener("click", submitGate);
if (entryForm){
  entryForm.addEventListener("submit", function(ev){
    if (!entryForm.getAttribute("action")){ ev.preventDefault(); submitGate(); }
  });
}

// ritorno da Shopify: si entra senza un secondo clic e l'indirizzo viene
// pulito. Chi si era gia' iscritto in una visita precedente entra subito.
if (/[?&](entered=1|customer_posted=true)\b/.test(window.location.search)){
  rememberEntry();
  enterRoom();
  if (window.history && window.history.replaceState){
    window.history.replaceState({}, "", window.location.pathname + window.location.hash);
  }
} else if (hasEntered()){
  enterRoom();
}

/* ==========================================================================
   19 / MOVIMENTO
   ========================================================================== */

// Resa cinematografica, come nelle Stanze 01 e 02.
// lookSmoothing: piu' alto = camera piu' reattiva, piu' basso = piu' inerzia.
var CINE = { lookSmoothing: 12, breath: 0.011 };
var camYaw = 0, camPitch = 0, camBreath = 0;
function move(dt){
  var fwd = 0, strafe = 0;
  if (!entered || uiOpen()){ keys = {}; }
  if (keys.KeyW || keys.ArrowUp) fwd += 1;
  if (keys.KeyS || keys.ArrowDown) fwd -= 1;
  if (keys.KeyA || keys.ArrowLeft) strafe -= 1;
  if (keys.KeyD || keys.ArrowRight) strafe += 1;
  if (stickVec.x || stickVec.y){ fwd += -stickVec.y; strafe += stickVec.x; }

  var len = Math.hypot(fwd, strafe);
  if (len > 1){ fwd /= len; strafe /= len; }

  var sin = Math.sin(yaw), cos = Math.cos(yaw);
  var dx = (strafe * cos - fwd * sin) * SPEED * dt;
  var dz = (-strafe * sin - fwd * cos) * SPEED * dt;

  var nx = camera.position.x + dx;
  var nz = camera.position.z + dz;
  var pad = 0.25;   // ingombro del visitatore: fra divano e tavolino si passa

  // pareti
  nx = Math.max(-HW + pad, Math.min(HW - pad, nx));
  nz = Math.max(-HD + pad, Math.min(HD - pad, nz));

  // arredi, risoluzione per asse
  var okX = true, okZ = true;
  for (var i=0; i<BLOCKS.length; i++){
    var b = BLOCKS[i];
    if (nx > b.x0-pad && nx < b.x1+pad && camera.position.z > b.z0-pad && camera.position.z < b.z1+pad) okX = false;
    if (camera.position.x > b.x0-pad && camera.position.x < b.x1+pad && nz > b.z0-pad && nz < b.z1+pad) okZ = false;
  }
  if (okX) camera.position.x = nx;
  if (okZ) camera.position.z = nz;

  // lo sguardo insegue l'angolo voluto invece di saltarci sopra
  var kLook = 1 - Math.exp(-CINE.lookSmoothing * dt);
  camYaw += (yaw - camYaw) * kLook;
  camPitch += (pitch - camPitch) * kLook;
  camera.rotation.order = "YXZ";
  camera.rotation.y = camYaw;
  camera.rotation.x = camPitch;
  // respiro: oscillazione verticale di ~1 cm, solo da fermi
  camBreath += dt;
  camera.position.y = EYE + (len > 0.001 ? 0 : CINE.breath * Math.sin(1.1 * camBreath));
}

/* ==========================================================================
   19b / DERIVA
   La stanza si riscrive mentre la abiti. Prima di spostarsi, un oggetto si
   guasta per un secondo: sussulta, va e viene, poi si ritrova dieci centimetri
   piu' in la'. Errori di continuita', non fenomeni.
   ========================================================================== */

var Deriva = {
  t: 0,
  wait: 5 + Math.random()*4,
  phase: 0,
  glitch: 0,
  target: null,

  // Niente scambio delle copertine: il cartellino accanto al disco deve
  // sempre corrispondere all'album. Si spostano solo gli oggetti.
  begin: function(){
    if (!DRIFT.length) return;
    var e = DRIFT[Math.floor(Math.random()*DRIFT.length)];
    e.rest = e.o.position.clone();
    e.dest = this.pick(e);
    this.target = e;
    this.phase = 1.0;
    Audio_.tear();
  },

  // dove finira' l'oggetto: dieci centimetri lungo i suoi assi liberi,
  // entro il raggio consentito attorno alla posizione di partenza
  pick: function(e){
    var ang = Math.random()*Math.PI*2;
    var p = e.rest.clone();
    var c0 = e.comp[0], c1 = e.comp[1];
    p[c0] += Math.cos(ang)*0.10;
    p[c1] += Math.sin(ang)*0.10;
    var d0 = p[c0] - e.home[c0];
    var d1 = p[c1] - e.home[c1];
    var dist = Math.sqrt(d0*d0 + d1*d1);
    if (dist > e.range){
      p[c0] = e.home[c0] + d0/dist*e.range;
      p[c1] = e.home[c1] + d1/dist*e.range;
    }
    return p;
  },

  settle: function(){
    var e = this.target;
    if (!e || !e.dest) return;
    e.o.position.copy(e.dest);
    if (Math.abs(e.o.rotation.x) > 1.0) e.o.rotation.z += (Math.random() - 0.5)*0.4;
    else e.o.rotation.y += (Math.random() - 0.5)*0.4;
    e.o.visible = true;
    this.target = null;
  },

  update: function(dt){
    if (this.phase > 0){
      this.phase -= dt;
      this.glitch = Math.max(0, Math.min(1, this.phase));
      var e = this.target;
      if (e && e.rest && e.dest){
        // durante il guasto l'oggetto non ha ancora deciso dove si trova:
        // sfarfalla fra la posizione vecchia e quella nuova
        var base = (Math.random() < 0.34) ? e.dest : e.rest;
        var k = 0.008 + (1 - this.phase)*0.018;
        e.o.position.set(base.x + (Math.random()-0.5)*k,
                         base.y + (Math.random()-0.5)*k*0.5,
                         base.z + (Math.random()-0.5)*k);
        e.o.visible = Math.random() > 0.18;
      }
      if (this.phase <= 0){
        this.phase = 0;
        this.glitch = 0;
        this.settle();
        this.t = 0;
        this.wait = 9 + Math.random()*10;
      }
      return;
    }
    this.t += dt;
    if (this.t >= this.wait) this.begin();
  }
};

/* ==========================================================================
   19c / GRANA DI STAMPA
   Un passaggio a schermo intero: velo di carta su tutto e microsfasamento di
   registro sul rosso, come la lastra del colore stampata fuori squadra.
   ========================================================================== */

function paperTexture(){
  var c = makeCanvas(512, 512);
  var x = c.getContext("2d");
  x.fillStyle = "#ffffff"; x.fillRect(0, 0, 512, 512);
  for (var i=0; i<9000; i++){
    var v = 228 + Math.floor(Math.random()*27);
    x.fillStyle = "rgba(" + v + "," + v + "," + (v-3) + ",0.55)";
    x.fillRect(Math.random()*512, Math.random()*512, 1 + Math.random()*2.4, 1);
  }
  for (var j=0; j<560; j++){
    x.fillStyle = "rgba(188,185,178,0.2)";
    x.beginPath();
    x.arc(Math.random()*512, Math.random()*512, 0.6 + Math.random()*2.2, 0, Math.PI*2);
    x.fill();
  }
  var t = new THREE.CanvasTexture(c);
  t.wrapS = THREE.RepeatWrapping;
  t.wrapT = THREE.RepeatWrapping;
  return t;
}

var Post = (function(){
  var params = { minFilter:THREE.LinearFilter, magFilter:THREE.LinearFilter, format:THREE.RGBAFormat };
  function makeTarget(w, h){
    if (THREE.WebGLMultisampleRenderTarget && renderer.capabilities && renderer.capabilities.isWebGL2){
      var m = new THREE.WebGLMultisampleRenderTarget(w, h, params);
      m.samples = 4;
      return m;
    }
    return new THREE.WebGLRenderTarget(w, h, params);
  }
  function pixels(){
    var dpr = renderer.getPixelRatio ? renderer.getPixelRatio() : 1;
    return {
      w: Math.max(2, Math.floor(window.innerWidth * dpr)),
      h: Math.max(2, Math.floor(window.innerHeight * dpr))
    };
  }
  var px = pixels();
  var target = makeTarget(px.w, px.h);

  var mat = new THREE.ShaderMaterial({
    depthTest: false,
    depthWrite: false,
    uniforms: {
      tDiffuse: { value: target.texture },
      tGrain:   { value: paperTexture() },
      uTile:    { value: new THREE.Vector2(px.w/384, px.h/384) },
      uTexel:   { value: new THREE.Vector2(1/px.w, 1/px.h) },
      uGrain:   { value: 0.17 },
      uRed:     { value: 1.35 },
      uGlitch:  { value: 0.0 }
    },
    vertexShader: [
      "varying vec2 vUv;",
      "void main(){",
      "  vUv = uv;",
      "  gl_Position = vec4(position.xy, 0.0, 1.0);",
      "}"
    ].join("\n"),
    fragmentShader: [
      "varying vec2 vUv;",
      "uniform sampler2D tDiffuse;",
      "uniform sampler2D tGrain;",
      "uniform vec2 uTile;",
      "uniform vec2 uTexel;",
      "uniform float uGrain;",
      "uniform float uRed;",
      "uniform float uGlitch;",
      "void main(){",
      "  vec2 off = vec2(0.84, -0.54) * (uRed + uGlitch * 6.0) * uTexel;",
      "  vec4 base = texture2D(tDiffuse, vUv);",
      "  float r = texture2D(tDiffuse, vUv + off).r;",
      "  vec3 col = vec3(r, base.g, base.b);",
      "  vec3 paper = texture2D(tGrain, vUv * uTile).rgb;",
      "  col *= mix(vec3(1.0), paper, uGrain);",
      "  vec3 srgb = mix(pow(col, vec3(0.41666)) * 1.055 - 0.055, col * 12.92,",
      "                  vec3(lessThanEqual(col, vec3(0.0031308))));",
      "  gl_FragColor = vec4(clamp(srgb, 0.0, 1.0), 1.0);",
      "}"
    ].join("\n")
  });

  var quadScene = new THREE.Scene();
  var quadCam = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
  quadScene.add(new THREE.Mesh(new THREE.PlaneGeometry(2, 2), mat));

  window.addEventListener("resize", function(){
    var q = pixels();
    target.setSize(q.w, q.h);
    mat.uniforms.uTile.value.set(q.w/384, q.h/384);
    mat.uniforms.uTexel.value.set(1/q.w, 1/q.h);
  });

  return {
    render: function(glitch){
      mat.uniforms.uGlitch.value = glitch;
      renderer.setRenderTarget(target);
      renderer.render(scene, camera);
      renderer.setRenderTarget(null);
      renderer.render(quadScene, quadCam);
    }
  };
})();

/* ==========================================================================
   20 / LOOP
   ========================================================================== */

var clock = new THREE.Clock();
var tvAcc = 0;

var renderedFrames = 0;

function frame(){
  var dt = Math.min(clock.getDelta(), 0.1);

  move(dt);
  updateHover();
  Audio_.listener(camera);

  // televisore a 15 fps, sufficiente e leggero su mobile
  tvAcc += dt;
  if (tvAcc > 0.066){ drawTV(tvAcc); tvAcc = 0; }

  // alone del televisore che respira
  var pulse = 0.34 + Math.sin(clock.elapsedTime*3.1)*0.03 + Math.random()*0.05;
  tvGlow.intensity = TV.vhs ? pulse*1.25 : pulse;
  if (TV.led) TV.led.material.color.setHex(TV.vhs ? 0xff3b3b : C.red);

  // fiore: oscillazione appena percettibile
  FLOWERS.forEach(function(f, i){
    f.rotation.y = camYaw - (f.userData.parentYaw || 0);   // segue la camera vera
    f.rotation.z = Math.sin(clock.elapsedTime*0.7 + i)*0.035;
  });

  // la foschia scorre piano e respira
  if (window.__clouds){
    window.__clouds.forEach(function(cl){
      cl.ph += dt*0.13;
      cl.m.position.z += cl.sp * dt;
      if (cl.m.position.z > 130) cl.m.position.z = -130;
      cl.m.rotation.y = camYaw;   // sempre di faccia, mai di taglio
      cl.m.material.opacity = cl.op * (0.78 + Math.sin(cl.ph)*0.22);
    });
  }

  // droni: crociera, poi sosta in stazionario a scandagliare
  if (window.__drones){
    window.__drones.forEach(function(dr){
      var u = dr.userData;
      u.ph += dt;
      u.hover -= dt;
      if (u.hover <= 0){
        u.scanning = !u.scanning;
        u.hover = u.scanning ? (4 + Math.random()*7) : (9 + Math.random()*16);
      }
      var v = u.scanning ? 0 : u.cruise;
      dr.position.z += v * dt;
      if (dr.position.z >  60) dr.position.z = -60;
      if (dr.position.z < -60) dr.position.z =  60;
      dr.position.y = u.base + Math.sin(u.ph*0.9)*u.bob;
      // il corpo si inclina in avanti quando avanza, si raddrizza in sosta
      dr.rotation.y = (u.cruise > 0 ? 0 : Math.PI);
      dr.rotation.x = u.scanning ? 0 : -0.12;
      dr.rotation.z = Math.sin(u.ph*0.7)*0.03;
      // la testa gira per conto suo, piu' larga quando e' ferma
      u.head.rotation.y = Math.sin(u.ph*(u.scanning ? 0.5 : 0.22)) * (u.scanning ? 0.9 : 0.3);
      u.head.rotation.x = Math.sin(u.ph*0.31)*0.18 - 0.1;
      u.led.visible = (u.ph % u.blink) < 0.1;
      for (var q=0; q<u.rot.length; q++) u.rot[q].rotation.z += dt*(11 + q*1.7);
    });
  }

  Deriva.update(dt);
  Post.render(Deriva.glitch);
  renderedFrames++;
}

function animate(){
  try {
    frame();
  } catch (e){
    fatal("The room stopped rendering.", e);
    return;
  }
  requestAnimationFrame(animate);
}
animate();

// se dopo sei secondi non e' stato disegnato niente, dillo invece di restare neri
setTimeout(function(){
  if (renderedFrames === 0)
    fatal("Nothing was drawn in six seconds.",
          "The graphics context didn't respond. Reload the page.");
}, 6000);

/* ==========================================================================
   NOTA PER SHOPIFY
   --------------------------------------------------------------------------
   (Nota storica: ora i dati arrivano da snippets/room03-hitlist.liquid,
   window.ROOM03_PRODUCTS / ROOM03_PACK / ROOM03_CHANNELS.)
   In produzione il blocco PRODUCTS non va scritto a mano. Nel file
   room04_custom_liquid.liquid, in un tag script inline prima di room04.js,
   si stampa la sorgente dati con Liquid, cosi le rimanenze restano vere:

     window.ROOM04_PRODUCTS = [
       {% for p in collections.decollectibus-zip.products %}
         {% if p.tags contains "hitlist" %}
         { code: "VOL",
           name: "{{ p.title | escape }}",
           handle: "{{ p.handle }}",
           img: "{{ p.featured_image | image_url: width: 700 }}",
           price: "{{ p.price | money_without_currency }}",
           edition: 5,
           left: {{ p.variants.first.inventory_quantity }} },
         {% endif %}
       {% endfor %}
     ];

   e in cima a questo file:
     var PRODUCTS = window.ROOM04_PRODUCTS || PRODUCTS;

   Stessa cosa per TV_CHANNELS, che puo' leggere gli URL
   dei file caricati in Shopify tramite il filtro file_url.
   ========================================================================== */

};

// Avvio, con un CDN di riserva se il primo non risponde.
(function(){
  if (window.THREE){ window.__bootRoom03(); return; }
  var s = document.createElement("script");
  s.src = "https://cdn.jsdelivr.net/npm/three@0.128.0/build/three.min.js";
  s.onload  = function(){ window.__bootRoom03(); };
  s.onerror = function(){ window.__bootRoom03(); };
  document.head.appendChild(s);
})();
